// src/index.ts
import { initContract as initContract24 } from "@ts-rest/core";

// src/contracts/auth.contract.ts
import { initContract } from "@ts-rest/core";
import { z as z4 } from "zod";

// src/enums/index.ts
import { z } from "zod";
var AGENCY_ROLES = ["agent", "back_office", "manager", "admin"];
var agencyRoleSchema = z.enum(AGENCY_ROLES);
var AGENCY_ROLE_LABELS = {
  agent: "Agente",
  back_office: "Back office",
  manager: "Responsabile",
  admin: "Amministratore"
};
var PLATFORM_ROLE = "platform_admin";
var ROLE_RANK = {
  agent: 0,
  back_office: 1,
  manager: 2,
  admin: 3
};

// src/enums/domain.ts
import { z as z2 } from "zod";
var CONTRACT_TYPES = ["sale", "rent"];
var contractTypeSchema = z2.enum(CONTRACT_TYPES);
var CONTRACT_TYPE_LABELS = {
  sale: "Vendita",
  rent: "Affitto"
};
var ENERGY_CLASSES = ["A4", "A3", "A2", "A1", "B", "C", "D", "E", "F", "G"];
var energyClassSchema = z2.enum(ENERGY_CLASSES);
var EXPOSURES = [
  "nord",
  "nord_est",
  "est",
  "sud_est",
  "sud",
  "sud_ovest",
  "ovest",
  "nord_ovest"
];
var exposureSchema = z2.enum(EXPOSURES);
var EXPOSURE_LABELS = {
  nord: "Nord",
  nord_est: "Nord-est",
  est: "Est",
  sud_est: "Sud-est",
  sud: "Sud",
  sud_ovest: "Sud-ovest",
  ovest: "Ovest",
  nord_ovest: "Nord-ovest"
};
var HEATINGS = ["autonomo", "centralizzato", "teleriscaldamento", "assente"];
var heatingSchema = z2.enum(HEATINGS);
var HEATING_LABELS = {
  autonomo: "Autonomo",
  centralizzato: "Centralizzato",
  teleriscaldamento: "Teleriscaldamento",
  assente: "Assente"
};
var PROPERTY_STATUSES = ["available", "under_offer", "sold", "rented"];
var propertyStatusSchema = z2.enum(PROPERTY_STATUSES);
var PROPERTY_STATUS_LABELS = {
  available: "Disponibile",
  under_offer: "Sotto proposta",
  sold: "Venduto",
  rented: "Affittato"
};
var OCCUPIED_BY = ["owner", "tenant", "free"];
var occupiedBySchema = z2.enum(OCCUPIED_BY);
var OCCUPIED_BY_LABELS = {
  owner: "Proprietario",
  tenant: "Inquilino",
  free: "Libero"
};
var DEMAND_STATUSES = ["open", "working", "won", "lost"];
var demandStatusSchema = z2.enum(DEMAND_STATUSES);
var DEMAND_STATUS_LABELS = {
  open: "Aperta",
  working: "In lavorazione",
  won: "Conclusa",
  lost: "Persa"
};
var CONTACT_KINDS = ["person", "company"];
var contactKindSchema = z2.enum(CONTACT_KINDS);
var CONTACT_SOURCES = ["manual", "whatsapp", "whatsapp_import"];
var CONTACT_KIND_LABELS = {
  person: "Persona fisica",
  company: "Azienda"
};
var INTERIOR_CONDITIONS = ["new", "renovated", "good", "to_renovate"];
var interiorConditionSchema = z2.enum(INTERIOR_CONDITIONS);
var INTERIOR_CONDITION_LABELS = {
  new: "Nuovo",
  renovated: "Ristrutturato",
  good: "Buono stato",
  to_renovate: "Da ristrutturare"
};
var EXTERIOR_CONDITIONS = ["new", "renovated", "good", "to_renovate"];
var exteriorConditionSchema = z2.enum(EXTERIOR_CONDITIONS);
var EXTERIOR_CONDITION_LABELS = {
  new: "Nuovo",
  renovated: "Ristrutturato",
  good: "Buono stato",
  to_renovate: "Da ristrutturare"
};
var FLOOR_LEVELS = [
  "basement",
  "ground",
  "raised",
  "mezzanine",
  "intermediate",
  "top",
  "penthouse",
  "multi_level"
];
var floorLevelSchema = z2.enum(FLOOR_LEVELS);
var FLOOR_LEVEL_LABELS = {
  basement: "Seminterrato",
  ground: "Piano terra",
  raised: "Rialzato",
  mezzanine: "Ammezzato",
  intermediate: "Piano intermedio",
  top: "Ultimo piano",
  penthouse: "Attico",
  multi_level: "Multipiano"
};
var PROPERTY_USES = [
  "residential",
  "commercial",
  "office",
  "industrial",
  "land",
  "other"
];
var propertyUseSchema = z2.enum(PROPERTY_USES);
var PROPERTY_USE_LABELS = {
  residential: "Residenziale",
  commercial: "Commerciale",
  office: "Ufficio",
  industrial: "Industriale",
  land: "Terreno",
  other: "Altro"
};
var OWNERSHIP_TYPES = ["full", "bare", "usufruct"];
var ownershipTypeSchema = z2.enum(OWNERSHIP_TYPES);
var OWNERSHIP_TYPE_LABELS = {
  full: "Piena propriet\xE0",
  bare: "Nuda propriet\xE0",
  usufruct: "Usufrutto"
};
var APPOINTMENT_OUTCOMES = ["done", "no_show", "postponed"];
var appointmentOutcomeSchema = z2.enum(APPOINTMENT_OUTCOMES);
var APPOINTMENT_OUTCOME_LABELS = {
  done: "Effettuato",
  no_show: "Non presentato",
  postponed: "Rinviato"
};
var GARDEN_TYPES = ["none", "private", "shared"];
var gardenTypeSchema = z2.enum(GARDEN_TYPES);
var GARDEN_TYPE_LABELS = {
  none: "Assente",
  private: "Privato",
  shared: "Condominiale"
};
var GARAGE_TYPES = ["none", "single", "double"];
var garageTypeSchema = z2.enum(GARAGE_TYPES);
var GARAGE_TYPE_LABELS = {
  none: "Assente",
  single: "Singolo",
  double: "Doppio"
};
var TYPOLOGY_LEVELS = ["macro", "typology", "category"];
var typologyLevelSchema = z2.enum(TYPOLOGY_LEVELS);
var TYPOLOGY_LEVEL_LABELS = {
  macro: "Macro-tipologia",
  typology: "Tipologia",
  category: "Categoria"
};
function enumOptions(values, labels) {
  return values.map((value) => ({ value, label: labels?.[value] ?? value }));
}
var CONTACT_CLASSIFICATIONS = ["lead", "partner", "condo_admin", "supplier"];
var contactClassificationSchema = z2.enum(CONTACT_CLASSIFICATIONS);
var CONTACT_CLASSIFICATION_LABELS = {
  lead: "Lead",
  partner: "Partner",
  condo_admin: "Amministratore di condominio",
  supplier: "Fornitore"
};
var DERIVED_ROLES = ["owner", "seller", "buyer", "tenant", "landlord"];
var derivedRoleSchema = z2.enum(DERIVED_ROLES);
var DERIVED_ROLE_LABELS = {
  owner: "Proprietario",
  seller: "Venditore",
  buyer: "Acquirente",
  tenant: "Inquilino",
  landlord: "Locatore"
};
var MEDIA_ROLES = ["cover", "photo", "floorplan", "document"];
var mediaRoleSchema = z2.enum(MEDIA_ROLES);
var MEDIA_ROLE_LABELS = {
  cover: "Copertina",
  photo: "Foto",
  floorplan: "Planimetria",
  document: "Documento"
};
var MANDATE_STATUSES = [
  "draft",
  "active",
  "suspended",
  "expired",
  "sold",
  "rented",
  "withdrawn"
];
var mandateStatusSchema = z2.enum(MANDATE_STATUSES);
var MANDATE_STATUS_LABELS = {
  draft: "Bozza",
  active: "Attivo",
  suspended: "Sospeso",
  expired: "Scaduto",
  sold: "Venduto",
  rented: "Affittato",
  withdrawn: "Revocato"
};
var MANDATE_ACTIONS = [
  "sign",
  "pause",
  "resume",
  "close",
  "withdraw",
  "renew",
  "expire"
];
var mandateActionSchema = z2.enum(MANDATE_ACTIONS);
var MANDATE_ACTION_LABELS = {
  sign: "Firma",
  pause: "Sospendi",
  resume: "Riattiva",
  close: "Chiudi",
  withdraw: "Revoca",
  renew: "Rinnova",
  expire: "Segna scaduto"
};
var MANDATE_TRANSITIONS = {
  draft: { sign: "active" },
  active: { pause: "suspended", withdraw: "withdrawn", expire: "expired", close: "sold" },
  suspended: { resume: "active", withdraw: "withdrawn" },
  expired: { renew: "active" },
  sold: {},
  rented: {},
  withdrawn: {}
};
function mandateTarget(status, action, contractType) {
  const target = MANDATE_TRANSITIONS[status][action];
  if (!target) return null;
  if (action === "close") return contractType === "rent" ? "rented" : "sold";
  return target;
}
function mandateActions(status) {
  return MANDATE_ACTIONS.filter((action) => Boolean(MANDATE_TRANSITIONS[status][action]));
}
function isMandateTerminal(status) {
  return mandateActions(status).length === 0;
}
var CONSENT_CHANNELS = ["privacy", "email", "whatsapp"];
var consentChannelSchema = z2.enum(CONSENT_CHANNELS);
var CONSENT_CHANNEL_LABELS = {
  privacy: "Trattamento dati",
  email: "Email marketing",
  whatsapp: "WhatsApp"
};
var ACTIVITY_TYPES = [
  "call",
  "appointment",
  "reminder",
  "note",
  "status_change",
  // Written by the inbound handler, never by a person (M8): a conversation on
  // the timeline is what makes a WhatsApp lead visible next to the phone calls
  // it competes with.
  "whatsapp"
];
var activityTypeSchema = z2.enum(ACTIVITY_TYPES);
var ACTIVITY_TYPE_LABELS = {
  call: "Chiamata",
  appointment: "Appuntamento",
  reminder: "Promemoria",
  note: "Nota",
  status_change: "Cambio di stato",
  whatsapp: "WhatsApp"
};
var ACTIVITY_SUBJECTS = ["contact", "property", "mandate", "demand"];
var activitySubjectSchema = z2.enum(ACTIVITY_SUBJECTS);
var ACTIVITY_SUBJECT_LABELS = {
  contact: "Contatto",
  property: "Immobile",
  mandate: "Incarico",
  demand: "Richiesta"
};
var CALL_OUTCOMES = ["answered", "no_answer", "callback", "wrong_number"];
var callOutcomeSchema = z2.enum(CALL_OUTCOMES);
var CALL_OUTCOME_LABELS = {
  answered: "Risposta",
  no_answer: "Nessuna risposta",
  callback: "Da richiamare",
  wrong_number: "Numero errato"
};
var CONSENT_LEGAL_BASES = ["consent", "contract", "legitimate_interest"];
var CONTACT_CHANNEL_KINDS = ["email", "phone", "mobile"];
var contactChannelKindSchema = z2.enum(CONTACT_CHANNEL_KINDS);
var CONTACT_CHANNEL_KIND_LABELS = {
  email: "Email",
  phone: "Telefono",
  mobile: "Cellulare"
};
var CONTACT_RELATION_TYPES = [
  "coniuge",
  "convivente",
  "figlio",
  "genitore",
  "fratello",
  "socio",
  "altro"
];
var contactRelationTypeSchema = z2.enum(CONTACT_RELATION_TYPES);
var CONTACT_RELATION_TYPE_LABELS = {
  coniuge: "Coniuge",
  convivente: "Convivente",
  figlio: "Figlio/a",
  genitore: "Genitore",
  fratello: "Fratello/Sorella",
  socio: "Socio",
  altro: "Altro"
};
var CONTACT_RELATION_INVERSE = {
  coniuge: "coniuge",
  convivente: "convivente",
  figlio: "genitore",
  genitore: "figlio",
  fratello: "fratello",
  socio: "socio",
  altro: "altro"
};
var REMINDER_DUE_STATES = ["overdue", "due_soon", "scheduled"];
var reminderDueStateSchema = z2.enum(REMINDER_DUE_STATES);
var REMINDER_DUE_STATE_LABELS = {
  overdue: "Scaduto",
  due_soon: "In scadenza",
  scheduled: "Programmato"
};
var WHATSAPP_CONNECTORS = ["baileys", "meta_cloud"];
var whatsappConnectorSchema = z2.enum(WHATSAPP_CONNECTORS);
var whatsappCapabilitiesSchema = z2.object({
  conversations: z2.boolean(),
  media: z2.boolean(),
  templates: z2.boolean(),
  bulk: z2.boolean()
});
var WHATSAPP_CAPABILITIES = {
  baileys: { conversations: true, media: true, templates: false, bulk: false },
  meta_cloud: { conversations: true, media: true, templates: true, bulk: true }
};
var WHATSAPP_CONNECTION_STATES = [
  "disconnected",
  "qr",
  "connecting",
  "connected",
  "banned"
];
var whatsappConnectionStateSchema = z2.enum(WHATSAPP_CONNECTION_STATES);
var WHATSAPP_CONNECTION_STATE_LABELS = {
  disconnected: "Non collegato",
  qr: "In attesa di scansione",
  connecting: "Collegamento in corso",
  connected: "Collegato",
  banned: "Numero bloccato da WhatsApp"
};
var WHATSAPP_HISTORY_MODES = ["none", "full"];
var whatsappHistoryModeSchema = z2.enum(WHATSAPP_HISTORY_MODES);
var WHATSAPP_HISTORY_MODE_LABELS = {
  none: "Parti da adesso",
  full: "Importa le conversazioni"
};
var WHATSAPP_HISTORY_WINDOWS = [3, 6, 12];
var whatsappHistoryWindowSchema = z2.union([z2.literal(3), z2.literal(6), z2.literal(12)]);
var WHATSAPP_HISTORY_STATES = ["idle", "running", "done", "failed"];
var whatsappHistoryStateSchema = z2.enum(WHATSAPP_HISTORY_STATES);
var MESSAGE_SOURCES = ["live", "import"];
var messageSourceSchema = z2.enum(MESSAGE_SOURCES);
var MESSAGE_MEDIA_STATES = ["none", "pending", "stored", "failed"];
var messageMediaStateSchema = z2.enum(MESSAGE_MEDIA_STATES);
var MESSAGE_DIRECTIONS = ["inbound", "outbound"];
var messageDirectionSchema = z2.enum(MESSAGE_DIRECTIONS);
var MESSAGE_TYPES = [
  "text",
  "image",
  "audio",
  "video",
  "document",
  "sticker",
  /**
   * Something WhatsApp delivered that the inbox cannot render — a location, a
   * contact card, a poll, a kind that did not exist when this was written.
   *
   * It is a type rather than a dropped delivery because the message happened:
   * an agent who can see that something arrived will open WhatsApp on the
   * phone, and one who sees nothing will answer a customer who thinks they
   * already said it.
   */
  "unsupported"
];
var messageTypeSchema = z2.enum(MESSAGE_TYPES);
var CONVERSATION_STATES = ["open", "closed"];
var conversationStateSchema = z2.enum(CONVERSATION_STATES);
var CONVERSATION_STATE_LABELS = {
  open: "Aperta",
  closed: "Chiusa"
};

// src/common/errors.ts
import { z as z3 } from "zod";
var errorSchema = z3.object({
  /** Stable, machine-readable code — safe to branch on. */
  code: z3.string(),
  /** Human-readable message. Already localized where it reaches a user. */
  message: z3.string(),
  /** Per-field validation messages, keyed by the form field path. */
  fields: z3.record(z3.string(), z3.array(z3.string())).optional(),
  /** Correlates with the X-Request-Id response header. */
  requestId: z3.string().optional()
});
var commonErrorResponses = {
  400: errorSchema,
  401: errorSchema,
  403: errorSchema,
  404: errorSchema,
  422: errorSchema,
  500: errorSchema
};

// src/contracts/auth.contract.ts
var c = initContract();
var sessionUserSchema = z4.object({
  id: z4.string().uuid(),
  email: z4.string().email(),
  name: z4.string(),
  roles: z4.array(agencyRoleSchema)
});
var sessionAgencySchema = z4.object({
  id: z4.string().uuid(),
  name: z4.string()
});
var sessionCapabilitiesSchema = z4.object({
  whatsapp: whatsappCapabilitiesSchema.extend({
    /** A capability the agency has not connected is still a capability it lacks today. */
    connected: z4.boolean()
  })
});
var sessionSchema = z4.object({
  /** Discriminant. False here, true on a platform session (M12). */
  platform: z4.literal(false),
  user: sessionUserSchema,
  agency: sessionAgencySchema,
  /** Serialized CASL rules; the UI hides what the API would refuse. */
  abilities: z4.array(
    z4.object({
      action: z4.union([z4.string(), z4.array(z4.string())]),
      subject: z4.union([z4.string(), z4.array(z4.string())]),
      conditions: z4.record(z4.string(), z4.unknown()).optional(),
      inverted: z4.boolean().optional()
    })
  ),
  capabilities: sessionCapabilitiesSchema,
  csrfToken: z4.string(),
  expiresAt: z4.string().datetime()
});
var platformSessionSchema = z4.object({
  platform: z4.literal(true),
  user: z4.object({
    id: z4.string(),
    email: z4.string().email(),
    name: z4.string()
  }),
  csrfToken: z4.string(),
  expiresAt: z4.string().datetime()
});
var sessionResponseSchema = z4.discriminatedUnion("platform", [
  sessionSchema,
  platformSessionSchema
]);
var authContract = c.router(
  {
    session: {
      method: "GET",
      path: "/auth/session",
      responses: { 200: sessionResponseSchema, 401: errorSchema },
      summary: "Current session, abilities and CSRF token."
    },
    logout: {
      method: "POST",
      path: "/auth/logout",
      body: z4.object({}),
      responses: {
        200: z4.object({ logoutUrl: z4.string().url().nullable() }),
        401: errorSchema
      },
      summary: "Destroys the session; returns the RP-initiated logout URL."
    }
  },
  { pathPrefix: "/api" }
);

// src/contracts/appointment-types.contract.ts
import { initContract as initContract2 } from "@ts-rest/core";
import { z as z6 } from "zod";

// src/common/pagination.ts
import { z as z5 } from "zod";
var DEFAULT_PAGE_SIZE = 25;
var MAX_PAGE_SIZE = 100;
var listQuerySchema = z5.object({
  page: z5.coerce.number().int().min(1).default(1),
  pageSize: z5.coerce.number().int().min(1).max(MAX_PAGE_SIZE).default(DEFAULT_PAGE_SIZE),
  sort: z5.string().optional(),
  order: z5.enum(["asc", "desc"]).default("asc"),
  q: z5.string().trim().min(1).optional()
});
var booleanQuery = z5.union([z5.boolean(), z5.enum(["true", "false", "1", "0"])]).transform((value) => typeof value === "boolean" ? value : value === "true" || value === "1");
var limitQuery = (max, fallback) => z5.coerce.number().int().min(1).max(max).default(fallback);
function paginated(item) {
  return z5.object({
    items: z5.array(item),
    page: z5.number().int(),
    pageSize: z5.number().int(),
    total: z5.number().int()
  });
}

// src/contracts/appointment-types.contract.ts
var c2 = initContract2();
var hexColorSchema = z6.string().trim().regex(/^#[0-9a-fA-F]{6}$/, "Usa un colore esadecimale, es. #b4552f");
var appointmentTypeSchema = z6.object({
  id: z6.string().uuid(),
  agencyId: z6.string().uuid(),
  code: z6.string(),
  label: z6.string(),
  color: z6.string(),
  textColor: z6.string(),
  sortOrder: z6.number().int(),
  active: z6.boolean(),
  createdAt: z6.string().datetime(),
  updatedAt: z6.string().datetime()
});
var appointmentTypeCreateSchema = z6.object({
  code: z6.string().trim().min(1, "Obbligatorio").max(16, "Massimo 16 caratteri").regex(/^[A-Z0-9_]+$/, "Solo maiuscole, cifre e underscore"),
  label: z6.string().trim().min(1, "Obbligatorio").max(120),
  color: hexColorSchema,
  textColor: hexColorSchema,
  sortOrder: z6.number().int().min(0).max(9999),
  active: z6.boolean()
});
var appointmentTypeUpdateSchema = appointmentTypeCreateSchema.partial();
var appointmentTypeListQuerySchema = listQuerySchema.extend({
  active: z6.union([z6.boolean(), z6.enum(["true", "false"])]).transform((value) => value === true || value === "true").optional()
});
var appointmentTypesContract = c2.router(
  {
    list: {
      method: "GET",
      path: "/appointment-types",
      query: appointmentTypeListQuerySchema,
      responses: { 200: paginated(appointmentTypeSchema), ...commonErrorResponses }
    },
    get: {
      method: "GET",
      path: "/appointment-types/:id",
      pathParams: z6.object({ id: z6.string().uuid() }),
      responses: { 200: appointmentTypeSchema, ...commonErrorResponses }
    },
    create: {
      method: "POST",
      path: "/appointment-types",
      body: appointmentTypeCreateSchema,
      responses: { 201: appointmentTypeSchema, ...commonErrorResponses }
    },
    update: {
      method: "PATCH",
      path: "/appointment-types/:id",
      pathParams: z6.object({ id: z6.string().uuid() }),
      body: appointmentTypeUpdateSchema,
      responses: { 200: appointmentTypeSchema, ...commonErrorResponses }
    },
    remove: {
      method: "DELETE",
      path: "/appointment-types/:id",
      pathParams: z6.object({ id: z6.string().uuid() }),
      responses: { 204: z6.null(), ...commonErrorResponses }
    }
  },
  { pathPrefix: "/api" }
);

// src/contracts/activities.contract.ts
import { initContract as initContract3 } from "@ts-rest/core";
import { z as z8 } from "zod";

// src/common/fields.ts
import { z as z7 } from "zod";
var blankOr = (schema) => z7.union([z7.literal(""), schema]).optional();
var optionalText = z7.string().trim().max(200, "Massimo 200 caratteri").optional();
var capSchema = z7.string().trim().regex(/^[0-9]{5}$/, "Il CAP \xE8 di 5 cifre");
var moneyInput = (message = "Importo non valido") => blankOr(
  z7.string().trim().regex(/^\d+(\.\d{1,2})?$/, message)
);
var addressShape = {
  addressStreet: z7.string().nullable(),
  addressNumber: z7.string().nullable(),
  addressPostalCode: z7.string().nullable(),
  comuneId: z7.string().uuid().nullable(),
  comuneName: z7.string().nullable(),
  sigla: z7.string().nullable()
};
var addressInputShape = {
  addressStreet: optionalText,
  addressNumber: optionalText,
  addressPostalCode: blankOr(capSchema),
  comuneId: blankOr(z7.string().uuid())
};
var latInput = z7.number().min(-90).max(90).nullable().optional();
var lngInput = z7.number().min(-180).max(180).nullable().optional();
var latQuery = z7.coerce.number().min(-90).max(90);
var lngQuery = z7.coerce.number().min(-180).max(180);
var radiusQuery = z7.coerce.number().int().min(100).max(2e5);

// src/contracts/activities.contract.ts
var c3 = initContract3();
var activitySchema = z8.object({
  id: z8.string().uuid(),
  /**
   * The code a person reads out on the phone (M14). Null on the status-change
   * entries the product writes on its own, which are given none.
   */
  reference: z8.string().nullable(),
  agencyId: z8.string().uuid(),
  type: activityTypeSchema,
  subjectType: activitySubjectSchema,
  subjectId: z8.string().uuid(),
  /** Resolved server-side, so a timeline entry can name what it is about. */
  subjectLabel: z8.string(),
  userId: z8.string().uuid().nullable(),
  userName: z8.string().nullable(),
  title: z8.string().nullable(),
  body: z8.string().nullable(),
  scheduledAt: z8.string().datetime().nullable(),
  endsAt: z8.string().datetime().nullable(),
  completedAt: z8.string().datetime().nullable(),
  /** Set by the sweep when a due reminder has been shown to its owner once. */
  surfacedAt: z8.string().datetime().nullable(),
  outcome: z8.string().nullable(),
  appointmentTypeId: z8.string().uuid().nullable(),
  appointmentTypeLabel: z8.string().nullable(),
  appointmentTypeColor: z8.string().nullable(),
  appointmentTypeTextColor: z8.string().nullable(),
  /**
   * Reminders only (U5): `overdue`, `due_soon` within eight working hours, or
   * `scheduled`. Computed by the API against the agency's timezone and opening
   * hours — the browser has neither.
   */
  dueState: reminderDueStateSchema.nullable(),
  /** Type-specific extras: an appointment's location, a call's proposals. */
  meta: z8.record(z8.string(), z8.unknown()),
  createdAt: z8.string().datetime(),
  updatedAt: z8.string().datetime()
});
var outcomeSchema = z8.union([callOutcomeSchema, appointmentOutcomeSchema, z8.literal("")]);
var activityCreateSchema = z8.object({
  type: activityTypeSchema,
  subjectType: activitySubjectSchema,
  subjectId: z8.string().uuid("Seleziona il soggetto"),
  userId: blankOr(z8.string().uuid()),
  title: z8.string().trim().max(200, "Massimo 200 caratteri").optional(),
  body: z8.string().trim().max(5e3, "Massimo 5000 caratteri").optional(),
  scheduledAt: blankOr(z8.string().datetime()),
  endsAt: blankOr(z8.string().datetime()),
  completedAt: blankOr(z8.string().datetime()),
  outcome: outcomeSchema.optional(),
  appointmentTypeId: blankOr(z8.string().uuid()),
  meta: z8.record(z8.string(), z8.unknown()).optional()
}).superRefine((value, ctx) => {
  if (value.type === "status_change") {
    ctx.addIssue({
      code: z8.ZodIssueCode.custom,
      path: ["type"],
      message: "I cambi di stato sono registrati dal sistema"
    });
  }
  if ((value.type === "appointment" || value.type === "reminder") && !value.scheduledAt) {
    ctx.addIssue({
      code: z8.ZodIssueCode.custom,
      path: ["scheduledAt"],
      message: "Indica quando"
    });
  }
  if (value.scheduledAt && value.endsAt && value.endsAt < value.scheduledAt) {
    ctx.addIssue({
      code: z8.ZodIssueCode.custom,
      path: ["endsAt"],
      message: "La fine precede l\u2019inizio"
    });
  }
  if (value.type === "note" && !value.body) {
    ctx.addIssue({ code: z8.ZodIssueCode.custom, path: ["body"], message: "Obbligatorio" });
  }
});
var activityUpdateSchema = activityCreateSchema;
var activityListQuerySchema = listQuerySchema.extend({
  type: activityTypeSchema.optional(),
  subjectType: activitySubjectSchema.optional(),
  subjectId: z8.string().uuid().optional(),
  userId: z8.string().uuid().optional(),
  appointmentTypeId: z8.string().uuid().optional(),
  /** The calendar's window, and the reminders dashboard's "due before". */
  scheduledFrom: z8.string().datetime().optional(),
  scheduledTo: z8.string().datetime().optional(),
  /** `false` is the open worklist: reminders nobody has dismissed yet. */
  completed: booleanQuery.optional(),
  /** Filters on the computed state, so "what is late" is one request (U5). */
  dueState: reminderDueStateSchema.optional()
});
var activityCompleteSchema = z8.object({
  completed: z8.boolean(),
  outcome: outcomeSchema.optional()
});
var activitiesContract = c3.router(
  {
    list: {
      method: "GET",
      path: "/activities",
      query: activityListQuerySchema,
      responses: { 200: paginated(activitySchema), ...commonErrorResponses }
    },
    get: {
      method: "GET",
      path: "/activities/:id",
      pathParams: z8.object({ id: z8.string().uuid() }),
      responses: { 200: activitySchema, ...commonErrorResponses }
    },
    create: {
      method: "POST",
      path: "/activities",
      body: activityCreateSchema,
      responses: { 201: activitySchema, ...commonErrorResponses }
    },
    update: {
      method: "PATCH",
      path: "/activities/:id",
      pathParams: z8.object({ id: z8.string().uuid() }),
      body: activityUpdateSchema,
      responses: { 200: activitySchema, ...commonErrorResponses }
    },
    /**
     * Dismissing a reminder or recording that an appointment happened.
     * Idempotent: completing what is already complete changes nothing.
     */
    complete: {
      method: "POST",
      path: "/activities/:id/complete",
      pathParams: z8.object({ id: z8.string().uuid() }),
      body: activityCompleteSchema,
      responses: { 200: activitySchema, ...commonErrorResponses }
    },
    remove: {
      method: "DELETE",
      path: "/activities/:id",
      pathParams: z8.object({ id: z8.string().uuid() }),
      responses: { 204: z8.null(), ...commonErrorResponses }
    }
  },
  { pathPrefix: "/api" }
);

// src/contracts/buildings.contract.ts
import { initContract as initContract4 } from "@ts-rest/core";
import { z as z9 } from "zod";
var c4 = initContract4();
var buildingSchema = z9.object({
  id: z9.string().uuid(),
  /**
   * The code a person reads out on the phone (M14), assigned when the record
   * is created.
   */
  reference: z9.string().nullable(),
  agencyId: z9.string().uuid(),
  name: z9.string(),
  ...addressShape,
  yearBuilt: z9.number().int().nullable(),
  hasElevator: z9.boolean(),
  administratorContactId: z9.string().uuid().nullable(),
  administratorName: z9.string().nullable(),
  notes: z9.string().nullable(),
  /** How many properties hang off it — the reason deleting one is a decision. */
  propertyCount: z9.number().int(),
  createdAt: z9.string().datetime(),
  updatedAt: z9.string().datetime()
});
var buildingCreateSchema = z9.object({
  name: z9.string().trim().min(1, "Obbligatorio").max(200),
  ...addressInputShape,
  yearBuilt: z9.number().int().min(1e3, "Anno non plausibile").max(2100, "Anno non plausibile").nullable().optional(),
  hasElevator: z9.boolean().optional(),
  administratorContactId: blankOr(z9.string().uuid()),
  notes: z9.string().trim().max(5e3, "Massimo 5000 caratteri").optional()
});
var buildingUpdateSchema = buildingCreateSchema;
var buildingListQuerySchema = listQuerySchema.extend({
  comuneId: z9.string().uuid().optional(),
  administratorContactId: z9.string().uuid().optional()
});
var buildingsContract = c4.router(
  {
    list: {
      method: "GET",
      path: "/buildings",
      query: buildingListQuerySchema,
      responses: { 200: paginated(buildingSchema), ...commonErrorResponses }
    },
    get: {
      method: "GET",
      path: "/buildings/:id",
      pathParams: z9.object({ id: z9.string().uuid() }),
      responses: { 200: buildingSchema, ...commonErrorResponses }
    },
    create: {
      method: "POST",
      path: "/buildings",
      body: buildingCreateSchema,
      responses: { 201: buildingSchema, ...commonErrorResponses }
    },
    update: {
      method: "PATCH",
      path: "/buildings/:id",
      pathParams: z9.object({ id: z9.string().uuid() }),
      body: buildingUpdateSchema,
      responses: { 200: buildingSchema, ...commonErrorResponses }
    },
    remove: {
      method: "DELETE",
      path: "/buildings/:id",
      pathParams: z9.object({ id: z9.string().uuid() }),
      responses: { 204: z9.null(), ...commonErrorResponses }
    }
  },
  { pathPrefix: "/api" }
);

// src/contracts/contacts.contract.ts
import { initContract as initContract5 } from "@ts-rest/core";
import { z as z10 } from "zod";

// src/validation/tax-ids.ts
var CODICE_FISCALE_PATTERN = /^[A-Z]{6}[0-9LMNPQRSTUV]{2}[ABCDEHLMPRST][0-9LMNPQRSTUV]{2}[A-Z][0-9LMNPQRSTUV]{3}[A-Z]$/;
var ODD_VALUES = {
  "0": 1,
  "1": 0,
  "2": 5,
  "3": 7,
  "4": 9,
  "5": 13,
  "6": 15,
  "7": 17,
  "8": 19,
  "9": 21,
  A: 1,
  B: 0,
  C: 5,
  D: 7,
  E: 9,
  F: 13,
  G: 15,
  H: 17,
  I: 19,
  J: 21,
  K: 2,
  L: 4,
  M: 18,
  N: 20,
  O: 11,
  P: 3,
  Q: 6,
  R: 8,
  S: 12,
  T: 14,
  U: 16,
  V: 10,
  W: 22,
  X: 25,
  Y: 24,
  Z: 23
};
var ALPHABET = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
function evenValue(char) {
  return /[0-9]/.test(char) ? Number(char) : ALPHABET.indexOf(char);
}
function normalizeTaxId(value) {
  return value.replace(/[\s.\-/]/g, "").toUpperCase();
}
function isValidCodiceFiscale(value) {
  const code = normalizeTaxId(value);
  if (/^[0-9]{11}$/.test(code)) return isValidPartitaIva(code);
  if (!CODICE_FISCALE_PATTERN.test(code)) return false;
  return codiceFiscaleCheckChar(code.slice(0, 15)) === code[15];
}
function codiceFiscaleCheckChar(payload) {
  let sum = 0;
  for (let i = 0; i < 15; i += 1) {
    const char = payload[i];
    sum += i % 2 === 0 ? ODD_VALUES[char] ?? 0 : evenValue(char);
  }
  return ALPHABET[sum % 26];
}
function isValidPartitaIva(value) {
  const code = normalizeTaxId(value);
  if (!/^[0-9]{11}$/.test(code)) return false;
  if (/^0{11}$/.test(code)) return false;
  return partitaIvaCheckDigit(code.slice(0, 10)) === code[10];
}
function partitaIvaCheckDigit(body) {
  let sum = 0;
  for (let i = 0; i < 10; i += 1) {
    const digit = Number(body[i]);
    if (i % 2 === 0) {
      sum += digit;
    } else {
      const doubled = digit * 2;
      sum += doubled > 9 ? doubled - 9 : doubled;
    }
  }
  return String((10 - sum % 10) % 10);
}

// src/contracts/contacts.contract.ts
var c5 = initContract5();
var contactClassificationEntrySchema = z10.object({
  classification: contactClassificationSchema,
  /** When the label started applying. Set on first assignment, never rewritten. */
  since: z10.string().date()
});
var contactChannelSchema = z10.object({
  id: z10.string().uuid(),
  kind: contactChannelKindSchema,
  value: z10.string(),
  label: z10.string().nullable(),
  isPrimary: z10.boolean()
});
var contactChannelInputSchema = z10.object({
  kind: contactChannelKindSchema,
  value: z10.string().trim().min(1, "Valore mancante").max(200),
  label: z10.string().trim().max(60).optional(),
  isPrimary: z10.boolean().optional()
});
var contactRelationSchema = z10.object({
  id: z10.string().uuid(),
  type: contactRelationTypeSchema,
  relatedContactId: z10.string().uuid(),
  relatedName: z10.string(),
  notes: z10.string().nullable(),
  inverse: z10.boolean()
});
var contactRelationInputSchema = z10.object({
  type: contactRelationTypeSchema,
  relatedContactId: z10.string().uuid("Contatto non valido"),
  notes: z10.string().trim().max(500).optional()
});
var contactSchema = z10.object({
  id: z10.string().uuid(),
  /**
   * The code a person reads out on the phone (M14). Null on a contact WhatsApp
   * created, which is given none.
   */
  reference: z10.string().nullable(),
  agencyId: z10.string().uuid(),
  kind: contactKindSchema,
  firstName: z10.string().nullable(),
  lastName: z10.string().nullable(),
  companyName: z10.string().nullable(),
  /**
   * Server-rendered so every list, picker and timeline entry names a contact the
   * same way — the alternative is each screen reimplementing the person/company
   * branch and drifting.
   */
  displayName: z10.string(),
  codiceFiscale: z10.string().nullable(),
  partitaIva: z10.string().nullable(),
  /**
   * The primary of each kind, derived from `channels` (U4). Kept on the read
   * model so the list column, the sort and every existing consumer go on
   * working after the recapiti moved to their own table.
   */
  email: z10.string().nullable(),
  phone: z10.string().nullable(),
  mobile: z10.string().nullable(),
  channels: z10.array(contactChannelSchema),
  ...addressShape,
  legalRepContactId: z10.string().uuid().nullable(),
  legalRepName: z10.string().nullable(),
  /** Both directions, the far side's label already flipped (U4). */
  relations: z10.array(contactRelationSchema),
  notes: z10.string().nullable(),
  classifications: z10.array(contactClassificationEntrySchema),
  /** Computed, never stored (ADR-0004). Empty until M4/M5 supply the sources. */
  derivedRoles: z10.array(derivedRoleSchema),
  createdAt: z10.string().datetime(),
  updatedAt: z10.string().datetime()
});
function present(value) {
  return typeof value === "string" && value.trim() !== "";
}
var contactCreateSchema = z10.object({
  kind: contactKindSchema,
  firstName: optionalText,
  lastName: optionalText,
  companyName: optionalText,
  codiceFiscale: optionalText,
  partitaIva: optionalText,
  /** The whole set, replacing what is stored: the form edits three lists. */
  channels: z10.array(contactChannelInputSchema).max(30).optional(),
  ...addressInputShape,
  legalRepContactId: blankOr(z10.string().uuid()),
  relations: z10.array(contactRelationInputSchema).max(30).optional(),
  notes: z10.string().trim().max(5e3, "Massimo 5000 caratteri").optional(),
  /** The whole set, not a delta: the form edits it as a multi-select. */
  classifications: z10.array(contactClassificationSchema).optional()
}).superRefine(contactRefinement);
function contactRefinement(value, ctx) {
  if (value.kind === "person" && !present(value.lastName)) {
    ctx.addIssue({ code: z10.ZodIssueCode.custom, path: ["lastName"], message: "Obbligatorio" });
  }
  if (value.kind === "company" && !present(value.companyName)) {
    ctx.addIssue({
      code: z10.ZodIssueCode.custom,
      path: ["companyName"],
      message: "Obbligatorio"
    });
  }
  if (value.kind === "person" && present(value.legalRepContactId)) {
    ctx.addIssue({
      code: z10.ZodIssueCode.custom,
      path: ["legalRepContactId"],
      message: "Solo le aziende hanno un rappresentante legale"
    });
  }
  if (present(value.codiceFiscale) && !isValidCodiceFiscale(value.codiceFiscale)) {
    ctx.addIssue({
      code: z10.ZodIssueCode.custom,
      path: ["codiceFiscale"],
      message: "Codice fiscale non valido"
    });
  }
  if (present(value.partitaIva) && !isValidPartitaIva(value.partitaIva)) {
    ctx.addIssue({
      code: z10.ZodIssueCode.custom,
      path: ["partitaIva"],
      message: "Partita IVA non valida"
    });
  }
}
var contactUpdateSchema = contactCreateSchema;
var contactListQuerySchema = listQuerySchema.extend({
  kind: contactKindSchema.optional(),
  classification: contactClassificationSchema.optional(),
  comuneId: z10.string().uuid().optional()
});
var contactDuplicateQuerySchema = z10.object({
  codiceFiscale: z10.string().trim().optional(),
  partitaIva: z10.string().trim().optional(),
  /** The contact being edited, excluded from its own duplicate list. */
  excludeId: z10.string().uuid().optional()
}).refine((value) => Boolean(value.codiceFiscale ?? value.partitaIva), {
  message: "Indicare codice fiscale o partita IVA"
});
var contactDuplicateSchema = z10.object({
  id: z10.string().uuid(),
  displayName: z10.string(),
  kind: contactKindSchema,
  codiceFiscale: z10.string().nullable(),
  partitaIva: z10.string().nullable()
});
var contactsContract = c5.router(
  {
    list: {
      method: "GET",
      path: "/contacts",
      query: contactListQuerySchema,
      responses: { 200: paginated(contactSchema), ...commonErrorResponses }
    },
    // Before `/contacts/:id`, which would otherwise swallow it.
    duplicates: {
      method: "GET",
      path: "/contacts/duplicates",
      query: contactDuplicateQuerySchema,
      responses: { 200: z10.array(contactDuplicateSchema), ...commonErrorResponses }
    },
    get: {
      method: "GET",
      path: "/contacts/:id",
      pathParams: z10.object({ id: z10.string().uuid() }),
      responses: { 200: contactSchema, ...commonErrorResponses }
    },
    create: {
      method: "POST",
      path: "/contacts",
      body: contactCreateSchema,
      responses: { 201: contactSchema, ...commonErrorResponses }
    },
    update: {
      method: "PATCH",
      path: "/contacts/:id",
      pathParams: z10.object({ id: z10.string().uuid() }),
      body: contactUpdateSchema,
      responses: { 200: contactSchema, ...commonErrorResponses }
    },
    remove: {
      method: "DELETE",
      path: "/contacts/:id",
      pathParams: z10.object({ id: z10.string().uuid() }),
      responses: { 204: z10.null(), ...commonErrorResponses }
    }
  },
  { pathPrefix: "/api" }
);

// src/contracts/demands.contract.ts
import { initContract as initContract7 } from "@ts-rest/core";
import { z as z12 } from "zod";

// src/contracts/properties.contract.ts
import { initContract as initContract6 } from "@ts-rest/core";
import { z as z11 } from "zod";
var c6 = initContract6();
var propertyMediaSchema = z11.object({
  id: z11.string().uuid(),
  role: mediaRoleSchema,
  position: z11.number().int(),
  /** Object key inside the bucket. Stable; the URL below is not. */
  path: z11.string(),
  fileName: z11.string(),
  contentType: z11.string(),
  sizeBytes: z11.number().int(),
  caption: z11.string().nullable(),
  /**
   * Presigned GET, minted per response and short-lived. The bucket is private:
   * a permanent URL would be a public one.
   */
  url: z11.string()
});
var propertySchema = z11.object({
  id: z11.string().uuid(),
  /**
   * The code a person reads out on the phone (M14), assigned when the record
   * is created.
   */
  reference: z11.string().nullable(),
  agencyId: z11.string().uuid(),
  /**
   * Built from the typology, the address and the comune. The domain has no
   * title column and inventing one would mean two names for one asset; this is
   * assembled server-side so every screen names a property identically.
   */
  displayLabel: z11.string(),
  buildingId: z11.string().uuid().nullable(),
  buildingName: z11.string().nullable(),
  typologyId: z11.string().uuid().nullable(),
  typologyLabel: z11.string().nullable(),
  typologyPath: z11.string().nullable(),
  use: propertyUseSchema,
  status: propertyStatusSchema,
  occupiedBy: occupiedBySchema,
  /** Money is a decimal string end to end. A float here is a rounding bug later. */
  price: z11.string().nullable(),
  surfaceMq: z11.number().int().nullable(),
  surfaceWalkableMq: z11.number().int().nullable(),
  locali: z11.number().int().nullable(),
  bagni: z11.number().int().nullable(),
  floor: z11.number().int().nullable(),
  floorLevel: floorLevelSchema.nullable(),
  energyClass: energyClassSchema.nullable(),
  heating: heatingSchema.nullable(),
  /** A set: a corner flat faces two ways (U3). Empty when nobody said. */
  exposure: z11.array(exposureSchema),
  ...addressShape,
  zonaId: z11.string().uuid().nullable(),
  zonaName: z11.string().nullable(),
  /** Read off the PostGIS point, which is the single stored position. */
  lat: z11.number().nullable(),
  lng: z11.number().nullable(),
  catastoFoglio: z11.string().nullable(),
  catastoParticella: z11.string().nullable(),
  catastoSubalterno: z11.string().nullable(),
  catastoCategoria: z11.string().nullable(),
  prestigio: z11.boolean(),
  attributes: z11.record(z11.string(), z11.unknown()),
  media: z11.array(propertyMediaSchema),
  createdAt: z11.string().datetime(),
  updatedAt: z11.string().datetime()
});
var optionalCount = (max, message) => z11.number().int().min(0, message).max(max, message).nullable().optional();
var PROPERTY_KNOWN_ATTRIBUTES = {
  garden: gardenTypeSchema,
  garage: garageTypeSchema,
  ownership: ownershipTypeSchema,
  interiorCondition: interiorConditionSchema,
  exteriorCondition: exteriorConditionSchema
};
var PROPERTY_KNOWN_ATTRIBUTE_KEYS = Object.keys(
  PROPERTY_KNOWN_ATTRIBUTES
);
var propertyKnownAttributesSchema = z11.object(PROPERTY_KNOWN_ATTRIBUTES).partial();
function isPropertyKnownAttribute(key) {
  return Object.prototype.hasOwnProperty.call(PROPERTY_KNOWN_ATTRIBUTES, key);
}
var propertyAttributesSchema = z11.record(
  z11.string().trim().min(1).max(64),
  z11.union([z11.string().max(500), z11.number(), z11.boolean(), z11.null()])
).superRefine((bag, ctx) => {
  for (const [key, value] of Object.entries(bag)) {
    if (!isPropertyKnownAttribute(key) || value === null) continue;
    if (!PROPERTY_KNOWN_ATTRIBUTES[key].safeParse(value).success) {
      ctx.addIssue({ code: z11.ZodIssueCode.custom, path: [key], message: "Valore non valido" });
    }
  }
});
var propertyMediaInputSchema = z11.object({
  /** The key the presigned upload wrote to. */
  path: z11.string().trim().min(1),
  role: mediaRoleSchema,
  fileName: z11.string().trim().min(1).max(255),
  contentType: z11.string().trim().min(1).max(120),
  sizeBytes: z11.number().int().min(0),
  caption: z11.string().trim().max(160).nullable().optional()
});
var propertyCreateSchema = z11.object({
  buildingId: blankOr(z11.string().uuid()),
  typologyId: blankOr(z11.string().uuid()),
  use: propertyUseSchema,
  status: propertyStatusSchema,
  occupiedBy: occupiedBySchema,
  price: moneyInput(),
  surfaceMq: optionalCount(1e6, "Superficie non plausibile"),
  surfaceWalkableMq: optionalCount(1e6, "Superficie non plausibile"),
  locali: optionalCount(100, "Numero non plausibile"),
  bagni: optionalCount(100, "Numero non plausibile"),
  floor: z11.number().int().min(-5).max(200).nullable().optional(),
  floorLevel: blankOr(floorLevelSchema),
  energyClass: blankOr(energyClassSchema),
  heating: blankOr(heatingSchema),
  exposure: z11.array(exposureSchema).max(8).optional(),
  ...addressInputShape,
  zonaId: blankOr(z11.string().uuid()),
  lat: latInput,
  lng: lngInput,
  catastoFoglio: optionalText,
  catastoParticella: optionalText,
  catastoSubalterno: optionalText,
  catastoCategoria: optionalText,
  prestigio: z11.boolean().optional(),
  attributes: propertyAttributesSchema.optional(),
  /** Sent whole: the client owns the order, the server replaces the set. */
  media: z11.array(propertyMediaInputSchema).max(60).optional()
}).superRefine((value, ctx) => {
  const hasLat = value.lat !== null && value.lat !== void 0;
  const hasLng = value.lng !== null && value.lng !== void 0;
  if (hasLat !== hasLng) {
    ctx.addIssue({
      code: z11.ZodIssueCode.custom,
      path: [hasLat ? "lng" : "lat"],
      message: "Latitudine e longitudine vanno indicate insieme"
    });
  }
  const covers = (value.media ?? []).filter((item) => item.role === "cover");
  if (covers.length > 1) {
    ctx.addIssue({
      code: z11.ZodIssueCode.custom,
      path: ["media"],
      message: "Una sola immagine pu\xF2 essere la copertina"
    });
  }
});
var propertyUpdateSchema = propertyCreateSchema;
var propertyListQuerySchema = listQuerySchema.extend({
  status: propertyStatusSchema.optional(),
  use: propertyUseSchema.optional(),
  typologyId: z11.string().uuid().optional(),
  /** Prefix over the denormalized typology path: `RES.` is everything residential. */
  typologyPath: z11.string().trim().min(1).optional(),
  comuneId: z11.string().uuid().optional(),
  zonaId: z11.string().uuid().optional(),
  buildingId: z11.string().uuid().optional(),
  priceMin: z11.coerce.number().min(0).optional(),
  priceMax: z11.coerce.number().min(0).optional(),
  surfaceMin: z11.coerce.number().int().min(0).optional(),
  surfaceMax: z11.coerce.number().int().min(0).optional(),
  localiMin: z11.coerce.number().int().min(0).optional(),
  localiMax: z11.coerce.number().int().min(0).optional(),
  prestigio: booleanQuery.optional(),
  /** Radius search: all three or none (ST_DWithin on the spheroid, metres). */
  lat: latQuery.optional(),
  lng: lngQuery.optional(),
  radius: radiusQuery.optional()
});
var uploadTicketRequestSchema = z11.object({
  fileName: z11.string().trim().min(1).max(255),
  contentType: z11.string().trim().regex(/^(image\/(jpeg|png|webp|avif)|application\/pdf)$/, "Tipo di file non consentito"),
  sizeBytes: z11.number().int().min(1).max(25 * 1024 * 1024, "Il file supera 25 MB")
});
var uploadTicketSchema = z11.object({
  /** PUT the bytes here, with the same Content-Type. */
  uploadUrl: z11.string(),
  /** What to send back in the property's `media` array. */
  path: z11.string(),
  expiresInSeconds: z11.number().int()
});
var propertiesContract = c6.router(
  {
    list: {
      method: "GET",
      path: "/properties",
      query: propertyListQuerySchema,
      responses: { 200: paginated(propertySchema), ...commonErrorResponses }
    },
    get: {
      method: "GET",
      path: "/properties/:id",
      pathParams: z11.object({ id: z11.string().uuid() }),
      responses: { 200: propertySchema, ...commonErrorResponses }
    },
    create: {
      method: "POST",
      path: "/properties",
      body: propertyCreateSchema,
      responses: { 201: propertySchema, ...commonErrorResponses }
    },
    update: {
      method: "PATCH",
      path: "/properties/:id",
      pathParams: z11.object({ id: z11.string().uuid() }),
      body: propertyUpdateSchema,
      responses: { 200: propertySchema, ...commonErrorResponses }
    },
    remove: {
      method: "DELETE",
      path: "/properties/:id",
      pathParams: z11.object({ id: z11.string().uuid() }),
      responses: { 204: z11.null(), ...commonErrorResponses }
    },
    uploadTicket: {
      method: "POST",
      path: "/properties/media/upload-url",
      body: uploadTicketRequestSchema,
      responses: { 201: uploadTicketSchema, ...commonErrorResponses }
    }
  },
  { pathPrefix: "/api" }
);

// src/contracts/demands.contract.ts
var c7 = initContract7();
var demandSchema = z12.object({
  id: z12.string().uuid(),
  /**
   * The code a person reads out on the phone (M14), assigned when the record
   * is created.
   */
  reference: z12.string().nullable(),
  agencyId: z12.string().uuid(),
  contactId: z12.string().uuid(),
  contactName: z12.string(),
  agentUserId: z12.string().uuid().nullable(),
  agentName: z12.string().nullable(),
  contractType: contractTypeSchema,
  use: propertyUseSchema,
  status: demandStatusSchema,
  typologyIds: z12.array(z12.string().uuid()),
  typologyLabels: z12.array(z12.string()),
  comuneIds: z12.array(z12.string().uuid()),
  comuneNames: z12.array(z12.string()),
  zonaIds: z12.array(z12.string().uuid()),
  zonaNames: z12.array(z12.string()),
  /** Money is a decimal string end to end. */
  budgetMin: z12.string().nullable(),
  budgetMax: z12.string().nullable(),
  surfaceMinMq: z12.number().int().nullable(),
  localiMin: z12.number().int().nullable(),
  /** Optional radius target, read off the stored PostGIS point. */
  lat: z12.number().nullable(),
  lng: z12.number().nullable(),
  radiusKm: z12.number().nullable(),
  /** The legacy privacy flag, as a real timestamp. Feeds `consents`. */
  privacyConsentAt: z12.string().datetime().nullable(),
  /** Sparse preferences, scored as feature overlap against a property's bag. */
  desiredAttributes: z12.record(z12.string(), z12.unknown()),
  notes: z12.string().nullable(),
  createdAt: z12.string().datetime(),
  updatedAt: z12.string().datetime()
});
var demandCreateSchema = z12.object({
  contactId: z12.string().uuid("Seleziona il contatto richiedente"),
  agentUserId: blankOr(z12.string().uuid()),
  contractType: contractTypeSchema,
  use: propertyUseSchema,
  status: demandStatusSchema,
  typologyIds: z12.array(z12.string().uuid()).max(20).optional(),
  comuneIds: z12.array(z12.string().uuid()).max(50).optional(),
  zonaIds: z12.array(z12.string().uuid()).max(50).optional(),
  budgetMin: moneyInput(),
  budgetMax: moneyInput(),
  surfaceMinMq: z12.number().int().min(0).max(1e6).nullable().optional(),
  localiMin: z12.number().int().min(0).max(100).nullable().optional(),
  lat: latInput,
  lng: lngInput,
  radiusKm: z12.number().min(0.1).max(200).nullable().optional(),
  /** Present means consent given; the API stamps the moment it arrives. */
  privacyConsent: z12.boolean().optional(),
  desiredAttributes: propertyAttributesSchema.optional(),
  notes: z12.string().trim().max(5e3, "Massimo 5000 caratteri").optional()
}).superRefine((value, ctx) => {
  if (value.budgetMin && value.budgetMax && Number(value.budgetMax) < Number(value.budgetMin)) {
    ctx.addIssue({
      code: z12.ZodIssueCode.custom,
      path: ["budgetMax"],
      message: "Il massimo \xE8 inferiore al minimo"
    });
  }
  const hasCentre = value.lat !== null && value.lat !== void 0;
  const hasLng = value.lng !== null && value.lng !== void 0;
  if (hasCentre !== hasLng) {
    ctx.addIssue({
      code: z12.ZodIssueCode.custom,
      path: [hasCentre ? "lng" : "lat"],
      message: "Latitudine e longitudine vanno indicate insieme"
    });
  }
  if (value.radiusKm && !hasCentre) {
    ctx.addIssue({
      code: z12.ZodIssueCode.custom,
      path: ["lat"],
      message: "Indica il centro del raggio"
    });
  }
});
var demandUpdateSchema = demandCreateSchema;
var demandMatchSchema = z12.object({
  propertyId: z12.string().uuid(),
  propertyLabel: z12.string(),
  mandateId: z12.string().uuid(),
  price: z12.string().nullable(),
  surfaceMq: z12.number().int().nullable(),
  locali: z12.number().int().nullable(),
  comuneName: z12.string().nullable(),
  zonaName: z12.string().nullable(),
  /** 0–100. Hard filters decide *whether*; this decides the order. */
  score: z12.number(),
  reasons: z12.array(z12.string()),
  /** When this pairing was first computed — the dedupe key for notifications. */
  firstSeenAt: z12.string().datetime()
});
var propertyMatchSchema = z12.object({
  demandId: z12.string().uuid(),
  contactName: z12.string(),
  agentName: z12.string().nullable(),
  status: demandStatusSchema,
  budgetMax: z12.string().nullable(),
  score: z12.number(),
  reasons: z12.array(z12.string()),
  firstSeenAt: z12.string().datetime()
});
var demandListQuerySchema = listQuerySchema.extend({
  status: demandStatusSchema.optional(),
  contractType: contractTypeSchema.optional(),
  use: propertyUseSchema.optional(),
  contactId: z12.string().uuid().optional(),
  agentUserId: z12.string().uuid().optional(),
  comuneId: z12.string().uuid().optional()
});
var demandsContract = c7.router(
  {
    list: {
      method: "GET",
      path: "/demands",
      query: demandListQuerySchema,
      responses: { 200: paginated(demandSchema), ...commonErrorResponses }
    },
    get: {
      method: "GET",
      path: "/demands/:id",
      pathParams: z12.object({ id: z12.string().uuid() }),
      responses: { 200: demandSchema, ...commonErrorResponses }
    },
    create: {
      method: "POST",
      path: "/demands",
      body: demandCreateSchema,
      responses: { 201: demandSchema, ...commonErrorResponses }
    },
    update: {
      method: "PATCH",
      path: "/demands/:id",
      pathParams: z12.object({ id: z12.string().uuid() }),
      body: demandUpdateSchema,
      responses: { 200: demandSchema, ...commonErrorResponses }
    },
    remove: {
      method: "DELETE",
      path: "/demands/:id",
      pathParams: z12.object({ id: z12.string().uuid() }),
      responses: { 204: z12.null(), ...commonErrorResponses }
    },
    /**
     * The matching workbench. A GET, because it is a read: the stored matches
     * are a cache for dedupe, not the answer — the answer is recomputed and
     * re-persisted on every visit, so a stale row can never mislead an agent.
     */
    matches: {
      method: "GET",
      path: "/demands/:id/matches",
      pathParams: z12.object({ id: z12.string().uuid() }),
      query: z12.object({ limit: limitQuery(100, 25) }),
      responses: { 200: z12.array(demandMatchSchema), ...commonErrorResponses }
    }
  },
  { pathPrefix: "/api" }
);
var propertyMatchesContract = c7.router(
  {
    interestedDemands: {
      method: "GET",
      path: "/properties/:id/demands",
      pathParams: z12.object({ id: z12.string().uuid() }),
      query: z12.object({ limit: limitQuery(100, 25) }),
      responses: { 200: z12.array(propertyMatchSchema), ...commonErrorResponses }
    }
  },
  { pathPrefix: "/api" }
);

// src/contracts/mandates.contract.ts
import { initContract as initContract8 } from "@ts-rest/core";
import { z as z13 } from "zod";
var c8 = initContract8();
var mandateSchema = z13.object({
  id: z13.string().uuid(),
  /**
   * The code a person reads out on the phone (M14), assigned when the record
   * is created.
   */
  reference: z13.string().nullable(),
  agencyId: z13.string().uuid(),
  propertyId: z13.string().uuid(),
  propertyLabel: z13.string(),
  ownerContactId: z13.string().uuid(),
  ownerName: z13.string(),
  agentUserId: z13.string().uuid().nullable(),
  agentName: z13.string().nullable(),
  contractType: contractTypeSchema,
  status: mandateStatusSchema,
  /** Asking price or rent. Money is a decimal string end to end. */
  price: z13.string().nullable(),
  commissionPct: z13.string().nullable(),
  commissionAmount: z13.string().nullable(),
  exclusive: z13.boolean(),
  signedAt: z13.string().date().nullable(),
  expiresAt: z13.string().date().nullable(),
  published: z13.boolean(),
  title: z13.string().nullable(),
  description: z13.string().nullable(),
  closedAt: z13.string().date().nullable(),
  closedPrice: z13.string().nullable(),
  /** The actions legal from the current state, resolved server-side. */
  availableActions: z13.array(z13.string()),
  createdAt: z13.string().datetime(),
  updatedAt: z13.string().datetime()
});
var mandateCreateSchema = z13.object({
  propertyId: z13.string().uuid("Seleziona un immobile"),
  ownerContactId: z13.string().uuid("Seleziona il proprietario mandante"),
  agentUserId: blankOr(z13.string().uuid()),
  contractType: contractTypeSchema,
  price: moneyInput(),
  commissionPct: z13.union([
    z13.literal(""),
    z13.string().trim().regex(/^\d{1,2}(\.\d{1,2})?$/, "Percentuale non valida")
  ]).optional(),
  commissionAmount: moneyInput(),
  exclusive: z13.boolean().optional(),
  signedAt: blankOr(z13.string().date()),
  expiresAt: blankOr(z13.string().date()),
  published: z13.boolean().optional(),
  title: z13.string().trim().max(200, "Massimo 200 caratteri").optional(),
  description: z13.string().trim().max(5e3, "Massimo 5000 caratteri").optional()
}).superRefine((value, ctx) => {
  if (value.signedAt && value.expiresAt && value.expiresAt < value.signedAt) {
    ctx.addIssue({
      code: z13.ZodIssueCode.custom,
      path: ["expiresAt"],
      message: "La scadenza precede la firma"
    });
  }
});
var mandateUpdateSchema = mandateCreateSchema;
var mandateTransitionSchema = z13.discriminatedUnion("action", [
  z13.object({ action: z13.literal("sign"), signedAt: z13.string().date().optional() }),
  z13.object({ action: z13.literal("pause") }),
  z13.object({ action: z13.literal("resume") }),
  z13.object({
    action: z13.literal("close"),
    closedAt: z13.string().date().optional(),
    closedPrice: moneyInput().optional()
  }),
  z13.object({ action: z13.literal("withdraw") }),
  z13.object({ action: z13.literal("renew"), expiresAt: z13.string().date() })
]);
var mandateListQuerySchema = listQuerySchema.extend({
  status: mandateStatusSchema.optional(),
  contractType: contractTypeSchema.optional(),
  propertyId: z13.string().uuid().optional(),
  ownerContactId: z13.string().uuid().optional(),
  agentUserId: z13.string().uuid().optional(),
  published: booleanQuery.optional(),
  exclusive: booleanQuery.optional(),
  /** Mandates lapsing inside a window — the renewal worklist. */
  expiresBefore: z13.string().date().optional()
});
var mandatesContract = c8.router(
  {
    list: {
      method: "GET",
      path: "/mandates",
      query: mandateListQuerySchema,
      responses: { 200: paginated(mandateSchema), ...commonErrorResponses }
    },
    get: {
      method: "GET",
      path: "/mandates/:id",
      pathParams: z13.object({ id: z13.string().uuid() }),
      responses: { 200: mandateSchema, ...commonErrorResponses }
    },
    create: {
      method: "POST",
      path: "/mandates",
      body: mandateCreateSchema,
      responses: { 201: mandateSchema, ...commonErrorResponses }
    },
    update: {
      method: "PATCH",
      path: "/mandates/:id",
      pathParams: z13.object({ id: z13.string().uuid() }),
      body: mandateUpdateSchema,
      responses: { 200: mandateSchema, ...commonErrorResponses }
    },
    transition: {
      method: "POST",
      path: "/mandates/:id/transition",
      pathParams: z13.object({ id: z13.string().uuid() }),
      body: mandateTransitionSchema,
      responses: { 200: mandateSchema, ...commonErrorResponses }
    },
    remove: {
      method: "DELETE",
      path: "/mandates/:id",
      pathParams: z13.object({ id: z13.string().uuid() }),
      responses: { 204: z13.null(), ...commonErrorResponses }
    }
  },
  { pathPrefix: "/api" }
);

// src/contracts/geo.contract.ts
import { initContract as initContract9 } from "@ts-rest/core";
import { z as z14 } from "zod";
var c9 = initContract9();
var regioneOptionSchema = z14.object({
  id: z14.string().uuid(),
  istatCode: z14.string(),
  name: z14.string()
});
var provinciaOptionSchema = regioneOptionSchema.extend({
  regioneId: z14.string().uuid(),
  sigla: z14.string()
});
var comuneOptionSchema = z14.object({
  id: z14.string().uuid(),
  istatCode: z14.string(),
  provinciaId: z14.string().uuid(),
  name: z14.string(),
  nameBilingual: z14.string(),
  codiceCatastale: z14.string(),
  cap: z14.string().nullable(),
  sigla: z14.string(),
  provinciaName: z14.string(),
  lat: z14.number(),
  lng: z14.number()
});
var comuneNearbyQuerySchema = z14.object({
  lat: latQuery,
  lng: lngQuery,
  /** Metres. Capped so a stray request cannot ask for the whole country. */
  radius: radiusQuery.default(1e4),
  limit: limitQuery(100, 25)
});
var comuneNearbySchema = comuneOptionSchema.extend({
  /** Metres from the requested point, on the spheroid. */
  distance: z14.number()
});
var geoContract = c9.router(
  {
    regioni: {
      method: "GET",
      path: "/geo/regioni",
      responses: { 200: z14.array(regioneOptionSchema), ...commonErrorResponses }
    },
    province: {
      method: "GET",
      path: "/geo/province",
      query: z14.object({ regioneId: z14.string().uuid().optional() }),
      responses: { 200: z14.array(provinciaOptionSchema), ...commonErrorResponses }
    },
    comuni: {
      method: "GET",
      path: "/geo/comuni",
      query: z14.object({
        provinciaId: z14.string().uuid().optional(),
        q: z14.string().trim().min(1).optional(),
        limit: limitQuery(100, 25)
      }),
      responses: { 200: z14.array(comuneOptionSchema), ...commonErrorResponses }
    },
    comune: {
      method: "GET",
      path: "/geo/comuni/:id",
      pathParams: z14.object({ id: z14.string().uuid() }),
      responses: { 200: comuneOptionSchema, ...commonErrorResponses }
    },
    comuniNearby: {
      method: "GET",
      // Not `/geo/comuni/nearby`: that collides with `/geo/comuni/:id`, and
      // which one wins depends on registration order.
      path: "/geo/comuni-nearby",
      query: comuneNearbyQuerySchema,
      responses: { 200: z14.array(comuneNearbySchema), ...commonErrorResponses }
    }
  },
  { pathPrefix: "/api" }
);

// src/contracts/property-typologies.contract.ts
import { initContract as initContract10 } from "@ts-rest/core";
import { z as z15 } from "zod";
var c10 = initContract10();
var propertyTypologySchema = z15.object({
  id: z15.string().uuid(),
  agencyId: z15.string().uuid(),
  parentId: z15.string().uuid().nullable(),
  parentLabel: z15.string().nullable(),
  level: typologyLevelSchema,
  code: z15.string(),
  label: z15.string(),
  path: z15.string(),
  /** Ancestor labels including this one, ready to render as a breadcrumb. */
  breadcrumb: z15.array(z15.string()),
  sortOrder: z15.number().int(),
  active: z15.boolean(),
  createdAt: z15.string().datetime(),
  updatedAt: z15.string().datetime()
});
var propertyTypologyCreateSchema = z15.object({
  parentId: z15.string().uuid().nullable().default(null),
  code: z15.string().trim().min(1, "Obbligatorio").max(32, "Massimo 32 caratteri").regex(/^[A-Z0-9_]+$/, "Solo maiuscole, cifre e underscore"),
  label: z15.string().trim().min(1, "Obbligatorio").max(120),
  sortOrder: z15.number().int().min(0).max(9999),
  active: z15.boolean()
});
var propertyTypologyUpdateSchema = propertyTypologyCreateSchema.partial();
var propertyTypologyListQuerySchema = listQuerySchema.extend({
  level: typologyLevelSchema.optional(),
  parentId: z15.string().uuid().optional(),
  /** Subtree filter: matches the row itself and everything under it. */
  pathPrefix: z15.string().trim().min(1).optional(),
  active: z15.union([z15.boolean(), z15.enum(["true", "false"])]).transform((value) => value === true || value === "true").optional()
});
var propertyTypologiesContract = c10.router(
  {
    list: {
      method: "GET",
      path: "/property-typologies",
      query: propertyTypologyListQuerySchema,
      responses: { 200: paginated(propertyTypologySchema), ...commonErrorResponses }
    },
    get: {
      method: "GET",
      path: "/property-typologies/:id",
      pathParams: z15.object({ id: z15.string().uuid() }),
      responses: { 200: propertyTypologySchema, ...commonErrorResponses }
    },
    create: {
      method: "POST",
      path: "/property-typologies",
      body: propertyTypologyCreateSchema,
      responses: { 201: propertyTypologySchema, ...commonErrorResponses }
    },
    update: {
      method: "PATCH",
      path: "/property-typologies/:id",
      pathParams: z15.object({ id: z15.string().uuid() }),
      body: propertyTypologyUpdateSchema,
      responses: { 200: propertyTypologySchema, ...commonErrorResponses }
    },
    remove: {
      method: "DELETE",
      path: "/property-typologies/:id",
      pathParams: z15.object({ id: z15.string().uuid() }),
      responses: { 204: z15.null(), ...commonErrorResponses }
    }
  },
  { pathPrefix: "/api" }
);

// src/contracts/zones.contract.ts
import { initContract as initContract11 } from "@ts-rest/core";
import { z as z16 } from "zod";
var c11 = initContract11();
var zoneSchema = z16.object({
  id: z16.string().uuid(),
  agencyId: z16.string().uuid(),
  comuneId: z16.string().uuid(),
  comuneName: z16.string(),
  sigla: z16.string(),
  name: z16.string(),
  hasGeometry: z16.boolean(),
  createdAt: z16.string().datetime(),
  updatedAt: z16.string().datetime()
});
var zoneCreateSchema = z16.object({
  comuneId: z16.string().uuid({ message: "Seleziona un comune" }),
  name: z16.string().trim().min(1, "Obbligatorio").max(120, "Massimo 120 caratteri")
});
var zoneUpdateSchema = zoneCreateSchema.partial();
var zoneListQuerySchema = listQuerySchema.extend({
  comuneId: z16.string().uuid().optional()
});
var zonesContract = c11.router(
  {
    list: {
      method: "GET",
      path: "/zones",
      query: zoneListQuerySchema,
      responses: { 200: paginated(zoneSchema), ...commonErrorResponses }
    },
    get: {
      method: "GET",
      path: "/zones/:id",
      pathParams: z16.object({ id: z16.string().uuid() }),
      responses: { 200: zoneSchema, ...commonErrorResponses }
    },
    create: {
      method: "POST",
      path: "/zones",
      body: zoneCreateSchema,
      responses: { 201: zoneSchema, ...commonErrorResponses }
    },
    update: {
      method: "PATCH",
      path: "/zones/:id",
      pathParams: z16.object({ id: z16.string().uuid() }),
      body: zoneUpdateSchema,
      responses: { 200: zoneSchema, ...commonErrorResponses }
    },
    remove: {
      method: "DELETE",
      path: "/zones/:id",
      pathParams: z16.object({ id: z16.string().uuid() }),
      responses: { 204: z16.null(), ...commonErrorResponses }
    }
  },
  { pathPrefix: "/api" }
);

// src/contracts/health.contract.ts
import { initContract as initContract12 } from "@ts-rest/core";
import { z as z17 } from "zod";
var c12 = initContract12();
var healthSchema = z17.object({
  status: z17.enum(["ok", "error"]),
  info: z17.record(z17.string(), z17.object({ status: z17.string() })).optional(),
  details: z17.record(z17.string(), z17.object({ status: z17.string() })).optional()
});
var healthContract = c12.router(
  {
    live: {
      method: "GET",
      path: "/health/live",
      responses: { 200: healthSchema },
      summary: "Liveness probe \u2014 the process is up."
    },
    ready: {
      method: "GET",
      path: "/health/ready",
      responses: { 200: healthSchema, 503: healthSchema },
      summary: "Readiness probe \u2014 Postgres and Redis are reachable."
    }
  },
  { pathPrefix: "/api" }
);

// src/contracts/users.contract.ts
import { initContract as initContract13 } from "@ts-rest/core";
import { z as z18 } from "zod";
var c13 = initContract13();
var userOptionSchema = z18.object({
  id: z18.string().uuid(),
  name: z18.string(),
  email: z18.string()
});
var agencyUserSchema = z18.object({
  id: z18.string().uuid().nullable(),
  subject: z18.string(),
  name: z18.string(),
  email: z18.string(),
  roles: z18.array(agencyRoleSchema),
  active: z18.boolean(),
  /** Null until they sign in for the first time. */
  lastLoginAt: z18.string().datetime().nullable(),
  /** Still holding an invitation they have not completed. */
  pending: z18.boolean()
});
var userInviteSchema = z18.object({
  email: z18.string().trim().email("Indirizzo non valido").max(200),
  firstName: z18.string().trim().min(1, "Obbligatorio").max(80),
  lastName: z18.string().trim().min(1, "Obbligatorio").max(80),
  roles: z18.array(agencyRoleSchema).min(1, "Almeno un ruolo")
});
var usersContract = c13.router(
  {
    /**
     * Administration (U7). Every one of these is scoped to the caller's agency
     * group by the API — the service account behind them can see the whole
     * realm, so the boundary is code, and it is tested as such.
     */
    list: {
      method: "GET",
      path: "/users",
      responses: { 200: z18.array(agencyUserSchema), ...commonErrorResponses }
    },
    invite: {
      method: "POST",
      path: "/users/invite",
      body: userInviteSchema,
      responses: { 201: agencyUserSchema, ...commonErrorResponses }
    },
    setRoles: {
      method: "PATCH",
      path: "/users/:subject/roles",
      pathParams: z18.object({ subject: z18.string() }),
      body: z18.object({ roles: z18.array(agencyRoleSchema).min(1, "Almeno un ruolo") }),
      responses: { 200: agencyUserSchema, ...commonErrorResponses }
    },
    /**
     * The person's name (U8). It lives in Keycloak; `users.name` is a mirror
     * the login rewrites, refreshed here so the screen that just renamed
     * somebody does not show the old name until their next sign-in.
     */
    setProfile: {
      method: "PATCH",
      path: "/users/:subject/profile",
      pathParams: z18.object({ subject: z18.string() }),
      body: z18.object({
        firstName: z18.string().trim().min(1, "Obbligatorio").max(80),
        lastName: z18.string().trim().min(1, "Obbligatorio").max(80)
      }),
      responses: { 200: agencyUserSchema, ...commonErrorResponses }
    },
    setActive: {
      method: "PATCH",
      path: "/users/:subject/active",
      pathParams: z18.object({ subject: z18.string() }),
      body: z18.object({ active: z18.boolean() }),
      responses: { 200: agencyUserSchema, ...commonErrorResponses }
    },
    resendInvitation: {
      method: "POST",
      path: "/users/:subject/invitation",
      pathParams: z18.object({ subject: z18.string() }),
      body: z18.object({}).optional(),
      responses: { 204: z18.null(), ...commonErrorResponses }
    },
    lookup: {
      method: "GET",
      path: "/users/lookup",
      query: z18.object({
        q: z18.string().trim().optional(),
        limit: limitQuery(50, 20)
      }),
      responses: { 200: z18.array(userOptionSchema), ...commonErrorResponses }
    }
  },
  { pathPrefix: "/api" }
);

// src/contracts/dashboard.contract.ts
import { initContract as initContract14 } from "@ts-rest/core";
import { z as z19 } from "zod";
var c14 = initContract14();
var dashboardSummarySchema = z19.object({
  appointmentsToday: z19.object({
    total: z19.number().int(),
    /** The next few, so the card says *what* and not only *how many*. */
    next: z19.array(activitySchema)
  }),
  reminders: z19.object({ open: z19.number().int(), overdue: z19.number().int() }),
  mandates: z19.object({ active: z19.number().int(), expiringIn30Days: z19.number().int() }),
  demands: z19.object({ open: z19.number().int(), withoutMatches: z19.number().int() }),
  properties: z19.object({ available: z19.number().int(), underOffer: z19.number().int() })
});
var dashboardContract = c14.router(
  {
    summary: {
      method: "GET",
      path: "/dashboard/summary",
      responses: { 200: dashboardSummarySchema, ...commonErrorResponses }
    }
  },
  { pathPrefix: "/api" }
);

// src/contracts/geocoding.contract.ts
import { initContract as initContract15 } from "@ts-rest/core";
import { z as z20 } from "zod";
var c15 = initContract15();
var geocodingResultSchema = z20.object({
  /** What the provider calls this place, for the option list. */
  label: z20.string(),
  street: z20.string().nullable(),
  number: z20.string().nullable(),
  postalCode: z20.string().nullable(),
  comuneName: z20.string().nullable(),
  /**
   * Resolved against our own `comuni` when the provider gives enough to do it
   * unambiguously — otherwise null, and the user picks the comune themselves. A
   * wrong comune silently breaks zone and radius search.
   */
  comuneId: z20.string().uuid().nullable(),
  lat: z20.number(),
  lng: z20.number()
});
var geocodingContract = c15.router(
  {
    search: {
      method: "GET",
      path: "/geocoding/search",
      query: z20.object({
        q: z20.string().trim().min(3).max(200),
        limit: limitQuery(10, 5)
      }),
      responses: { 200: z20.array(geocodingResultSchema), ...commonErrorResponses }
    },
    reverse: {
      method: "GET",
      path: "/geocoding/reverse",
      query: z20.object({
        lat: latQuery,
        lng: lngQuery
      }),
      responses: {
        200: geocodingResultSchema.nullable(),
        ...commonErrorResponses
      }
    }
  },
  { pathPrefix: "/api" }
);

// src/contracts/zone-catalog.contract.ts
import { initContract as initContract16 } from "@ts-rest/core";
import { z as z21 } from "zod";
var c16 = initContract16();
var ZONE_TIERS = ["quartiere", "zona", "microzona"];
var DEFAULT_ZONE_TIERS = ["quartiere", "zona"];
var ZONE_TIER_LABELS = {
  quartiere: "Quartieri",
  zona: "Zone",
  microzona: "Microzone"
};
var zoneImportTierSchema = z21.object({
  tier: z21.string(),
  available: z21.number().int(),
  alreadyImported: z21.number().int()
});
var zoneImportPreviewSchema = z21.object({
  comuneId: z21.string().uuid(),
  comuneName: z21.string(),
  sigla: z21.string().nullable(),
  /** In the catalogue for this comune, whatever the agency already has. */
  available: z21.number().int(),
  /** Already imported from the same source, and therefore skipped. */
  alreadyImported: z21.number().int(),
  /** What an import would actually create. */
  toImport: z21.number().int(),
  /**
   * The same figures split by level, so the dialog can offer the choice and
   * recount without another round trip.
   */
  tiers: z21.array(zoneImportTierSchema)
});
var zoneImportResultSchema = z21.object({
  imported: z21.number().int(),
  skipped: z21.number().int()
});
var comuneIds = z21.array(z21.string().uuid()).min(1, "Scegli almeno un comune").max(200);
var zoneCatalogContract = c16.router(
  {
    preview: {
      method: "POST",
      path: "/zone-catalog/preview",
      // POST for a read: a hundred comune ids do not belong in a query string.
      // `sources` is a list because the catalogue is built from more than one
      // OSM layer and which one a row came from is a mapping detail (U9); the
      // screen omits it. `tiers` is the choice the screen does make: omitted
      // means every level, which is what the preview counts.
      body: z21.object({
        comuneIds,
        sources: z21.array(z21.string()).nonempty().optional(),
        tiers: z21.array(z21.string()).nonempty().optional()
      }),
      responses: { 200: z21.array(zoneImportPreviewSchema), ...commonErrorResponses }
    },
    import: {
      method: "POST",
      path: "/zone-catalog/import",
      // `sources` is a list because the catalogue is built from more than one
      // OSM layer and which one a row came from is a mapping detail (U9); the
      // screen omits it. `tiers` is the choice the screen does make: omitted
      // means every level, which is what the preview counts.
      body: z21.object({
        comuneIds,
        sources: z21.array(z21.string()).nonempty().optional(),
        tiers: z21.array(z21.string()).nonempty().optional()
      }),
      responses: { 200: zoneImportResultSchema, ...commonErrorResponses }
    }
  },
  { pathPrefix: "/api" }
);

// src/contracts/agency.contract.ts
import { initContract as initContract17 } from "@ts-rest/core";
import { z as z22 } from "zod";
var c17 = initContract17();
var interval = z22.tuple([
  z22.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/, "Formato HH:MM"),
  z22.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/, "Formato HH:MM")
]);
var businessHoursSchema = z22.object({
  mon: z22.array(interval).max(4),
  tue: z22.array(interval).max(4),
  wed: z22.array(interval).max(4),
  thu: z22.array(interval).max(4),
  fri: z22.array(interval).max(4),
  sat: z22.array(interval).max(4),
  sun: z22.array(interval).max(4)
});
var agencySchema = z22.object({
  id: z22.string().uuid(),
  name: z22.string(),
  slug: z22.string(),
  email: z22.string().nullable(),
  phone: z22.string().nullable(),
  mobile: z22.string().nullable(),
  ...addressShape,
  timezone: z22.string(),
  businessHours: businessHoursSchema
});
var agencyUpdateSchema = z22.object({
  name: z22.string().trim().min(1, "Obbligatorio").max(200),
  email: blankOr(z22.string().trim().email("Indirizzo non valido").max(200)),
  phone: optionalText,
  mobile: optionalText,
  ...addressInputShape,
  /** An IANA zone. Reminder states are computed in it (U5). */
  timezone: z22.string().trim().min(1).max(60),
  businessHours: businessHoursSchema
});
var agencyContract = c17.router(
  {
    get: {
      method: "GET",
      path: "/agency",
      responses: { 200: agencySchema, ...commonErrorResponses }
    },
    update: {
      method: "PATCH",
      path: "/agency",
      body: agencyUpdateSchema,
      responses: { 200: agencySchema, ...commonErrorResponses }
    }
  },
  { pathPrefix: "/api" }
);

// src/contracts/platform.contract.ts
import { initContract as initContract19 } from "@ts-rest/core";
import { z as z24 } from "zod";

// src/contracts/assistant.contract.ts
import { initContract as initContract18 } from "@ts-rest/core";
import { z as z23 } from "zod";
var c18 = initContract18();
var chartSeriesSchema = z23.object({
  key: z23.string().min(1),
  label: z23.string().min(1)
});
var chartTypeSchema = z23.enum(["bar", "line", "pie"]);
var chartSpecSchema = z23.object({
  type: chartTypeSchema,
  title: z23.string().min(1),
  x: z23.string().min(1),
  series: z23.array(chartSeriesSchema).min(1),
  data: z23.array(z23.record(z23.string(), z23.unknown()))
}).superRefine((spec, ctx) => {
  const [firstRow] = spec.data;
  if (!firstRow) return;
  const columns = new Set(Object.keys(firstRow));
  if (!columns.has(spec.x)) {
    ctx.addIssue({
      code: z23.ZodIssueCode.custom,
      path: ["x"],
      message: `x names no column in the data: ${spec.x}`
    });
  }
  spec.series.forEach((series, index) => {
    if (!columns.has(series.key)) {
      ctx.addIssue({
        code: z23.ZodIssueCode.custom,
        path: ["series", index, "key"],
        message: `series names no column in the data: ${series.key}`
      });
    }
  });
  if (spec.type === "pie" && spec.series.length > 1) {
    ctx.addIssue({
      code: z23.ZodIssueCode.custom,
      path: ["series"],
      message: "a pie chart cannot have more than one series"
    });
  }
});
var assistantSessionSchema = z23.object({
  id: z23.string().uuid(),
  title: z23.string().nullable(),
  pinned: z23.boolean(),
  updatedAt: z23.string()
});
var assistantTextSegmentSchema = z23.object({
  kind: z23.literal("text"),
  text: z23.string()
});
var assistantToolSegmentSchema = z23.object({
  kind: z23.literal("tool"),
  tool: z23.string(),
  ok: z23.boolean(),
  summary: z23.string()
});
var assistantChartSegmentSchema = z23.object({
  kind: z23.literal("chart"),
  spec: chartSpecSchema
});
var assistantRecordKindSchema = z23.enum(["property", "mandate", "demand", "contact"]);
var assistantRecordRefSchema = z23.object({
  kind: assistantRecordKindSchema,
  id: z23.string().uuid()
});
var assistantRecordsSegmentSchema = z23.object({
  kind: z23.literal("records"),
  refs: z23.array(assistantRecordRefSchema)
});
var assistantSegmentSchema = z23.discriminatedUnion("kind", [
  assistantTextSegmentSchema,
  assistantToolSegmentSchema,
  assistantChartSegmentSchema,
  assistantRecordsSegmentSchema
]);
var assistantMessageSchema = z23.discriminatedUnion("role", [
  z23.object({ role: z23.literal("user"), content: z23.string() }),
  z23.object({ role: z23.literal("assistant"), segments: z23.array(assistantSegmentSchema) })
]);
var assistantReportCreateSchema = z23.object({
  notes: z23.string().trim().max(2e3).default("")
});
var assistantSessionDetailSchema = assistantSessionSchema.extend({
  messages: z23.array(assistantMessageSchema),
  /** The model this conversation runs on; null means the agency's default. */
  modelId: z23.string().nullable()
});
var assistantModelOptionSchema = z23.object({
  modelId: z23.string(),
  label: z23.string(),
  isDefault: z23.boolean()
});
var assistantSessionCreateSchema = z23.object({
  title: z23.string().trim().min(1).max(200).optional(),
  /** Which model to start the conversation on. Omitted takes the default. */
  modelId: z23.string().optional()
});
var assistantSessionModelSchema = z23.object({
  modelId: z23.string().min(1)
});
var assistantSessionUpdateSchema = z23.object({
  title: z23.string().trim().min(1).max(200).nullable().optional(),
  pinned: z23.boolean().optional()
}).refine((body) => body.title !== void 0 || body.pinned !== void 0, {
  message: "Niente da aggiornare."
});
var assistantUsageByModelSchema = z23.object({
  modelId: z23.string(),
  turns: z23.number().int(),
  promptTokens: z23.number().int(),
  completionTokens: z23.number().int(),
  cachedTokens: z23.number().int(),
  costCents: z23.number()
});
var assistantUsageByUserSchema = z23.object({
  userId: z23.string().uuid().nullable(),
  name: z23.string(),
  turns: z23.number().int(),
  promptTokens: z23.number().int(),
  completionTokens: z23.number().int(),
  costCents: z23.number()
});
var assistantUsageDaySchema = z23.object({
  /** `YYYY-MM-DD`, in the database's timezone — the same clock the month is cut on. */
  day: z23.string(),
  turns: z23.number().int(),
  costCents: z23.number()
});
var assistantUsageSummarySchema = z23.object({
  monthStart: z23.string(),
  spentCents: z23.number(),
  budgetCents: z23.number().nullable(),
  turns: z23.number().int(),
  promptTokens: z23.number().int(),
  completionTokens: z23.number().int(),
  cachedTokens: z23.number().int(),
  byModel: z23.array(assistantUsageByModelSchema),
  byUser: z23.array(assistantUsageByUserSchema),
  byDay: z23.array(assistantUsageDaySchema)
});
var assistantRecordCardSchema = z23.object({
  kind: assistantRecordKindSchema,
  id: z23.string().uuid(),
  found: z23.boolean(),
  title: z23.string(),
  subtitle: z23.string().nullable(),
  details: z23.array(z23.string()),
  /** A short-lived presigned URL, minted per response and never stored. */
  imageUrl: z23.string().nullable(),
  /** Where the card leads inside the app, e.g. `/immobili/<id>`. */
  href: z23.string()
});
var assistantRecordsRequestSchema = z23.object({
  refs: z23.array(assistantRecordRefSchema).min(1).max(20)
});
var assistantContract = c18.router(
  {
    /**
     * The models this agency may use. One entry means the screen shows no
     * selector — there is nothing to select — and the conversation runs on it
     * either way.
     */
    models: {
      method: "GET",
      path: "/assistant/models",
      responses: { 200: z23.array(assistantModelOptionSchema), ...commonErrorResponses }
    },
    /** Changes the model a conversation runs on, from the next question. */
    setSessionModel: {
      method: "PUT",
      path: "/assistant/sessions/:id/model",
      pathParams: z23.object({ id: z23.string().uuid() }),
      body: assistantSessionModelSchema,
      responses: { 204: z23.null(), ...commonErrorResponses }
    },
    /**
     * What this agency has spent on the assistant this month, and against
     * which ceiling. Aggregated server-side: no question, no answer and no
     * per-person breakdown crosses this route, only totals.
     */
    usage: {
      method: "GET",
      path: "/assistant/usage",
      responses: { 200: assistantUsageSummarySchema, ...commonErrorResponses }
    },
    /**
     * The cards for records an answer pointed at.
     *
     * A POST because the body carries record ids: a GET would put them in a
     * query string, which is exactly where tenant identifiers must not be
     * (they reach proxy logs and browser history). Nothing is created.
     *
     * Resolved fresh on every read, tenant-scoped, so the transcript stores
     * references and this route decides what may be seen of them today.
     */
    records: {
      method: "POST",
      path: "/assistant/records",
      body: assistantRecordsRequestSchema,
      responses: { 200: z23.array(assistantRecordCardSchema), ...commonErrorResponses }
    },
    /**
     * Hands this conversation to the operator, with a note. What crosses is
     * the transcript the person saw — text, tool chips, charts and record
     * references — never the rows the tools returned.
     */
    reportSession: {
      method: "POST",
      path: "/assistant/sessions/:id/report",
      pathParams: z23.object({ id: z23.string().uuid() }),
      body: assistantReportCreateSchema,
      responses: { 201: z23.object({ id: z23.string().uuid() }), ...commonErrorResponses }
    },
    sessions: {
      method: "GET",
      path: "/assistant/sessions",
      responses: { 200: z23.array(assistantSessionSchema), ...commonErrorResponses }
    },
    session: {
      method: "GET",
      path: "/assistant/sessions/:id",
      pathParams: z23.object({ id: z23.string().uuid() }),
      responses: { 200: assistantSessionDetailSchema, ...commonErrorResponses }
    },
    createSession: {
      method: "POST",
      path: "/assistant/sessions",
      body: assistantSessionCreateSchema,
      responses: { 201: assistantSessionSchema, ...commonErrorResponses }
    },
    updateSession: {
      method: "PATCH",
      path: "/assistant/sessions/:id",
      pathParams: z23.object({ id: z23.string().uuid() }),
      body: assistantSessionUpdateSchema,
      responses: { 200: assistantSessionSchema, ...commonErrorResponses }
    },
    removeSession: {
      method: "DELETE",
      path: "/assistant/sessions/:id",
      pathParams: z23.object({ id: z23.string().uuid() }),
      responses: { 204: z23.null(), ...commonErrorResponses }
    }
  },
  { pathPrefix: "/api" }
);

// src/contracts/platform.contract.ts
var c19 = initContract19();
var AGENCY_DELETION_STATUSES = ["pending", "running", "failed", "done"];
var agencyDeletionStatusSchema = z24.enum(AGENCY_DELETION_STATUSES);
var agencyDeletionSchema = z24.object({
  status: agencyDeletionStatusSchema,
  lastError: z24.string().nullable(),
  requestedAt: z24.string().datetime()
});
var unfinishedAgencyDeletionSchema = z24.object({
  agencyId: z24.string().uuid(),
  slug: z24.string(),
  name: z24.string(),
  status: agencyDeletionStatusSchema,
  lastError: z24.string().nullable(),
  requestedAt: z24.string().datetime(),
  agencyExists: z24.boolean()
});
var agencyDeletionPreviewSchema = z24.object({
  contacts: z24.number().int(),
  properties: z24.number().int(),
  demands: z24.number().int(),
  mandates: z24.number().int(),
  conversations: z24.number().int(),
  campaigns: z24.number().int(),
  files: z24.number().int(),
  users: z24.number().int(),
  keycloakUsers: z24.number().int()
});
var platformAgencySchema = z24.object({
  id: z24.string().uuid(),
  name: z24.string(),
  slug: z24.string(),
  /** The three characters this agency's business references start with (M14). */
  code: z24.string(),
  email: z24.string().nullable(),
  phone: z24.string().nullable(),
  ...addressShape,
  timezone: z24.string(),
  active: z24.boolean(),
  createdAt: z24.string().datetime(),
  /** How many mirror rows point at this agency — people, not records. */
  userCount: z24.number().int(),
  /** False when the realm has no group for this slug: the tenant is half made. */
  hasGroup: z24.boolean(),
  /** The tombstone of a deletion in progress or failed; null for an agency not being deleted. */
  deletion: agencyDeletionSchema.nullable()
});
var platformUserSchema = z24.object({
  id: z24.string().uuid(),
  subject: z24.string(),
  name: z24.string(),
  email: z24.string(),
  roles: z24.array(agencyRoleSchema),
  active: z24.boolean(),
  lastLoginAt: z24.string().datetime().nullable(),
  agencyId: z24.string().uuid(),
  agencyName: z24.string()
});
var slugSchema = z24.string().trim().min(2, "Almeno 2 caratteri").max(40).regex(/^[a-z0-9][a-z0-9-]*[a-z0-9]$/, "Solo minuscole, cifre e trattini");
var agencyCreateSchema = z24.object({
  name: z24.string().trim().min(1, "Obbligatorio").max(200),
  slug: slugSchema,
  email: z24.union([z24.literal(""), z24.string().trim().email("Indirizzo non valido").max(200)]).optional(),
  phone: z24.string().trim().max(200).optional(),
  timezone: z24.string().trim().min(1).max(60).default("Europe/Rome"),
  /**
   * The agency's first administrator, invited in the same call. An agency
   * without one is an agency nobody can get into: the operator does not
   * administer it themselves, so somebody inside it has to be able to.
   */
  admin: z24.object({
    email: z24.string().trim().email("Indirizzo non valido").max(200),
    firstName: z24.string().trim().min(1, "Obbligatorio").max(80),
    lastName: z24.string().trim().min(1, "Obbligatorio").max(80)
  })
});
var agencyCreateResultSchema = z24.object({
  agency: platformAgencySchema,
  invitationSent: z24.boolean()
});
var platformAgencyUpdateSchema = z24.object({
  name: z24.string().trim().min(1, "Obbligatorio").max(200),
  email: z24.union([z24.literal(""), z24.string().trim().email("Indirizzo non valido").max(200)]).optional(),
  phone: z24.string().trim().max(200).optional(),
  timezone: z24.string().trim().min(1).max(60)
});
var platformAgencyMetricSchema = z24.object({
  /** The agency's own calendar day, `YYYY-MM-DD`. */
  day: z24.string(),
  properties: z24.number().int(),
  contacts: z24.number().int(),
  mandates: z24.number().int(),
  demands: z24.number().int(),
  activities: z24.number().int(),
  appointments: z24.number().int(),
  usersActive: z24.number().int(),
  usersSignedIn: z24.number().int(),
  mediaCount: z24.number().int(),
  mediaBytes: z24.number().int(),
  computedAt: z24.string().datetime()
});
var platformFeatureUsageSchema = z24.object({
  day: z24.string(),
  name: z24.string(),
  count: z24.number().int(),
  users: z24.number().int(),
  /** Distinct users in the 30 days ending with `day`. */
  users30d: z24.number().int()
});
var platformAssistantViewSchema = z24.object({
  id: z24.string().uuid(),
  viewName: z24.string(),
  /** What the model reads. Free text, neutralised before it reaches the
   *  prompt (`apps/api/src/assistant/prompt-assembler.ts`) — safe to let an
   *  operator type markup into it. */
  description: z24.string(),
  active: z24.boolean(),
  updatedAt: z24.string().datetime()
});
var updateAssistantViewSchema = z24.object({
  active: z24.boolean().optional(),
  description: z24.string().trim().min(1, "Obbligatorio").max(2e3).optional()
}).refine((body) => body.active !== void 0 || body.description !== void 0, {
  message: "Niente da aggiornare."
});
var platformAssistantPromptSchema = z24.object({
  id: z24.string().uuid(),
  version: z24.number().int(),
  content: z24.string(),
  note: z24.string().nullable(),
  modelId: z24.string().nullable(),
  active: z24.boolean(),
  createdAt: z24.string().datetime()
});
var createAssistantPromptSchema = z24.object({
  content: z24.string().trim().min(1, "Obbligatorio"),
  note: z24.string().trim().max(500).optional(),
  modelId: z24.string().trim().max(200).optional()
});
var assistantSettingsSchema = z24.record(z24.string(), z24.string());
var updateAssistantSettingsSchema = z24.record(z24.string(), z24.string()).refine((body) => Object.keys(body).length > 0, { message: "Niente da aggiornare." });
var platformAssistantUsageSchema = z24.object({
  agencyId: z24.string().uuid(),
  agencyName: z24.string(),
  costCents: z24.number(),
  promptTokens: z24.number().int(),
  completionTokens: z24.number().int(),
  turns: z24.number().int()
});
var ASSISTANT_REPORT_STATUSES = ["open", "closed"];
var assistantReportStatusSchema = z24.enum(ASSISTANT_REPORT_STATUSES);
var platformAssistantReportSchema = z24.object({
  id: z24.string().uuid(),
  agencyId: z24.string().uuid(),
  agencyName: z24.string(),
  userId: z24.string().uuid().nullable(),
  userEmail: z24.string().nullable(),
  userName: z24.string().nullable(),
  sessionId: z24.string().uuid().nullable(),
  sessionTitle: z24.string().nullable(),
  modelId: z24.string().nullable(),
  status: assistantReportStatusSchema,
  createdAt: z24.string().datetime(),
  closedAt: z24.string().datetime().nullable()
});
var platformAssistantReportDetailSchema = platformAssistantReportSchema.extend({
  notes: z24.string(),
  transcript: z24.array(assistantMessageSchema)
});
var assistantCredentialStatusSchema = z24.object({
  configured: z24.boolean(),
  fingerprint: z24.string().nullable(),
  updatedAt: z24.string().nullable(),
  /** This agency's own monthly ceiling in cents; null falls back to the global one. */
  monthlyBudgetCents: z24.number().int().nullable()
});
var setAssistantCredentialSchema = z24.object({
  /**
   * Trimmed, because a key pasted from a dashboard arrives with whitespace
   * more often than not, and a stored key with a trailing newline fails
   * authentication in a way nothing on this screen would explain.
   */
  apiKey: z24.string().trim().min(20).max(400)
});
var platformAssistantModelSchema = z24.object({
  modelId: z24.string(),
  label: z24.string(),
  displayName: z24.string().nullable(),
  active: z24.boolean(),
  sortOrder: z24.number().int(),
  supportsTools: z24.boolean(),
  /**
   * Whether OpenRouter serves this model from at least one zero-data-retention
   * endpoint. False makes it unusable: every completion is sent with
   * `provider: { zdr: true }`, so such a model has nowhere to route.
   */
  supportsZdr: z24.boolean(),
  contextLength: z24.number().int().nullable(),
  /** Null when the catalogue has never priced it; such a model cannot be used. */
  inputCentsPerMillion: z24.number().nullable(),
  outputCentsPerMillion: z24.number().nullable(),
  pricingFetchedAt: z24.string().nullable()
});
var registerAssistantModelSchema = z24.object({
  modelId: z24.string().trim().min(3).max(200),
  /** The operator's own word for what the model is for. Not an enum: it is
   *  their vocabulary, and a fixed set is a migration between somebody and a
   *  label they wanted. */
  label: z24.string().trim().min(1).max(40),
  active: z24.boolean().optional(),
  sortOrder: z24.number().int().optional()
});
var agencyAssistantModelsSchema = z24.object({
  modelIds: z24.array(z24.string()).max(20),
  defaultModelId: z24.string().nullable()
});
var setAssistantBudgetSchema = z24.object({
  monthlyBudgetCents: z24.number().int().positive().nullable()
});
var WEBSITE_LEAD_KINDS = ["contact", "demo"];
var websiteLeadKindSchema = z24.enum(WEBSITE_LEAD_KINDS);
var WEBSITE_LEAD_KIND_LABELS = {
  contact: "Contatto",
  demo: "Demo"
};
var WEBSITE_LEAD_STATUSES = ["new", "contacted", "closed"];
var websiteLeadStatusSchema = z24.enum(WEBSITE_LEAD_STATUSES);
var WEBSITE_LEAD_STATUS_LABELS = {
  new: "Nuova",
  contacted: "Contattata",
  closed: "Chiusa"
};
var websiteLeadSchema = z24.object({
  id: z24.string().uuid(),
  kind: websiteLeadKindSchema,
  name: z24.string(),
  agency: z24.string(),
  email: z24.string(),
  phone: z24.string(),
  message: z24.string(),
  /** What the visitor was shown when they consented, kept for the record. */
  privacyVersion: z24.string(),
  privacyUrl: z24.string(),
  createdAt: z24.string().datetime(),
  status: websiteLeadStatusSchema,
  notes: z24.string(),
  handledBy: z24.string(),
  handledAt: z24.string().datetime().nullable(),
  /** Where it came from (M17): empty strings when the visit was direct. */
  utmSource: z24.string(),
  utmMedium: z24.string(),
  utmCampaign: z24.string(),
  /** The referring host, never a URL. */
  referrer: z24.string(),
  /** The page the visitor landed on, never its query. */
  landingPath: z24.string()
});
function describeLeadSource(lead) {
  const campaign = [lead.utmSource, lead.utmMedium, lead.utmCampaign].filter(Boolean).join(" \xB7 ");
  const origin = campaign || (lead.referrer ? `da ${lead.referrer}` : "Diretta");
  const via = campaign && lead.referrer ? ` (da ${lead.referrer})` : "";
  const landing = lead.landingPath && lead.landingPath !== "/" ? `, su ${lead.landingPath}` : "";
  return `${origin}${via}${landing}`;
}
var websiteLeadUpdateSchema = z24.object({
  status: websiteLeadStatusSchema.optional(),
  notes: z24.string().trim().max(3e3).optional()
}).refine((value) => value.status !== void 0 || value.notes !== void 0, {
  message: "Niente da aggiornare."
});
var platformContract = c19.router(
  {
    listAgencies: {
      method: "GET",
      path: "/platform/agencies",
      responses: { 200: z24.array(platformAgencySchema), ...commonErrorResponses },
      summary: "Every agency on the platform."
    },
    getAgency: {
      method: "GET",
      path: "/platform/agencies/:id",
      pathParams: z24.object({ id: z24.string().uuid() }),
      responses: { 200: platformAgencySchema, ...commonErrorResponses }
    },
    /**
     * The free slug for a name, so the form can show it while it is being
     * typed rather than refusing it at submit.
     *
     * Uniqueness is the server's knowledge, so the server is what answers.
     * Advisory only: the constraint is still the database's, because two
     * operators can be typing the same name at the same moment.
     */
    slugSuggestion: {
      method: "GET",
      path: "/platform/agencies/slug-suggestion",
      query: z24.object({ name: z24.string().trim().min(1).max(200) }),
      responses: {
        200: z24.object({ slug: z24.string(), taken: z24.boolean() }),
        ...commonErrorResponses
      }
    },
    createAgency: {
      method: "POST",
      path: "/platform/agencies",
      body: agencyCreateSchema,
      responses: { 201: agencyCreateResultSchema, ...commonErrorResponses },
      summary: "Provisions a tenant: row, Keycloak group, first admin invitation."
    },
    updateAgency: {
      method: "PATCH",
      path: "/platform/agencies/:id",
      pathParams: z24.object({ id: z24.string().uuid() }),
      body: platformAgencyUpdateSchema,
      responses: { 200: platformAgencySchema, ...commonErrorResponses }
    },
    /**
     * Suspension is the reversible step: it stops access without touching the
     * rows, which are somebody's business records. Deletion is `deleteAgency`
     * and requires the agency to be suspended first.
     */
    setAgencyActive: {
      method: "PATCH",
      path: "/platform/agencies/:id/active",
      pathParams: z24.object({ id: z24.string().uuid() }),
      body: z24.object({ active: z24.boolean() }),
      responses: { 200: platformAgencySchema, ...commonErrorResponses }
    },
    agencyDeletionPreview: {
      method: "GET",
      path: "/platform/agencies/:id/deletion-preview",
      pathParams: z24.object({ id: z24.string().uuid() }),
      responses: { 200: agencyDeletionPreviewSchema, 409: errorSchema, ...commonErrorResponses },
      summary: "What deleting this suspended agency would destroy, as counts."
    },
    /**
     * Permanent deletion of a suspended agency (ADR-0020): every row, file and
     * Keycloak account. Asynchronous — 202 and a tombstone the detail polls.
     * `confirmSlug` is the second confirmation, re-checked here. With a failed
     * deletion behind it, this is the retry.
     */
    deleteAgency: {
      method: "DELETE",
      path: "/platform/agencies/:id",
      pathParams: z24.object({ id: z24.string().uuid() }),
      body: z24.object({ confirmSlug: z24.string().min(1) }),
      responses: { 202: agencyDeletionSchema, 409: errorSchema, ...commonErrorResponses }
    },
    /**
     * Deletions the operator still has to look at, newest first: `failed`, and
     * `pending`/`running` ones that may be stuck. The way back to a deletion
     * whose agency no longer appears in `listAgencies`; the retry is `deleteAgency`.
     */
    listUnfinishedAgencyDeletions: {
      method: "GET",
      path: "/platform/agency-deletions",
      responses: { 200: z24.array(unfinishedAgencyDeletionSchema), ...commonErrorResponses }
    },
    /**
     * One agency's daily history, newest first (M13).
     *
     * On the detail route and not on the list, because the list is a list of
     * agencies rather than a dashboard. An absent day is a day the job did not
     * run; nothing fills the gap, and there is no backfill — history starts the
     * day the job first ran, and inventing what a count was last month would put
     * made-up numbers in a table meant to price contracts.
     */
    agencyMetrics: {
      method: "GET",
      path: "/platform/agencies/:id/metrics",
      pathParams: z24.object({ id: z24.string().uuid() }),
      query: z24.object({
        days: z24.coerce.number().int().min(1).max(365).default(30)
      }),
      responses: {
        200: z24.array(platformAgencyMetricSchema),
        ...commonErrorResponses
      }
    },
    /**
     * One agency's feature usage, day by day, for the `days` ending with the
     * last day counted (M17). Anchored on that day rather than on today, so a
     * job that stopped running shows its last numbers instead of nothing.
     *
     * Recounted by `refreshAgencyMetrics`: one button, both tables.
     */
    agencyFeatureUsage: {
      method: "GET",
      path: "/platform/agencies/:id/feature-usage",
      pathParams: z24.object({ id: z24.string().uuid() }),
      query: z24.object({
        days: z24.coerce.number().int().min(1).max(365).default(30)
      }),
      responses: {
        200: z24.array(platformFeatureUsageSchema),
        ...commonErrorResponses
      }
    },
    /**
     * Recomputes today's row for one agency, now.
     *
     * Enqueued rather than run here: the counting belongs in the worker, inside
     * each tenant's scope, and the API process reading a tenant's content on the
     * operator's behalf is the thing this whole boundary exists to prevent. So
     * the answer is 202 and the screen reloads — the number is a day old at
     * worst, and the boundary stays where it is.
     *
     * Idempotent per `(agency, day)`: pressing it twice overwrites, and never
     * leaves a second row behind.
     */
    refreshAgencyMetrics: {
      method: "POST",
      path: "/platform/agencies/:id/metrics/refresh",
      pathParams: z24.object({ id: z24.string().uuid() }),
      // Nothing to send: the agency is in the path. `z.null()` would refuse the
      // empty body the client actually puts on the wire.
      body: z24.object({}).optional(),
      responses: { 202: z24.null(), ...commonErrorResponses }
    },
    /** Retries the first-admin invitation when provisioning could not send it. */
    inviteAgencyAdmin: {
      method: "POST",
      path: "/platform/agencies/:id/invite",
      pathParams: z24.object({ id: z24.string().uuid() }),
      body: z24.object({
        email: z24.string().trim().email("Indirizzo non valido").max(200),
        firstName: z24.string().trim().min(1, "Obbligatorio").max(80),
        lastName: z24.string().trim().min(1, "Obbligatorio").max(80)
      }),
      responses: { 204: z24.null(), ...commonErrorResponses }
    },
    listUsers: {
      method: "GET",
      path: "/platform/users",
      query: z24.object({
        agencyId: z24.string().uuid().optional(),
        q: z24.string().trim().max(200).optional()
      }),
      responses: { 200: z24.array(platformUserSchema), ...commonErrorResponses },
      summary: "Every user on the platform, filterable by agency."
    },
    /**
     * Deactivation only, and deliberately: inviting and granting roles inside
     * a tenant belong to that tenant's own admin, who has the screen for them.
     * An operator quietly giving themself a role inside an agency is the shape
     * of abuse this whole module is arranged against. Stopping an account is
     * the one lever that cannot be delegated — not when the account to stop is
     * the agency's only admin.
     */
    setUserActive: {
      method: "PATCH",
      path: "/platform/users/:subject/active",
      pathParams: z24.object({ subject: z24.string() }),
      body: z24.object({ active: z24.boolean() }),
      responses: { 200: platformUserSchema, ...commonErrorResponses }
    },
    /** The curated views the model may read, and what each is told about it. */
    listAssistantViews: {
      method: "GET",
      path: "/platform/assistant/views",
      responses: { 200: z24.array(platformAssistantViewSchema), ...commonErrorResponses }
    },
    /** Toggles a view's allowlist membership, or edits what the model is told about it. */
    updateAssistantView: {
      method: "PATCH",
      path: "/platform/assistant/views/:viewName",
      pathParams: z24.object({ viewName: z24.string() }),
      body: updateAssistantViewSchema,
      responses: { 200: platformAssistantViewSchema, ...commonErrorResponses }
    },
    /** Every authored version of the system prompt, newest first. */
    listAssistantPrompts: {
      method: "GET",
      path: "/platform/assistant/prompts",
      responses: { 200: z24.array(platformAssistantPromptSchema), ...commonErrorResponses }
    },
    /** A new version, inactive until it is activated. */
    createAssistantPrompt: {
      method: "POST",
      path: "/platform/assistant/prompts",
      body: createAssistantPromptSchema,
      responses: { 201: platformAssistantPromptSchema, ...commonErrorResponses }
    },
    /**
     * Makes one version the one the model is given, and no other. The
     * database enforces "exactly one active" through a partial unique index
     * (`assistant_prompts_one_active`); two operators activating different
     * versions at the same moment produce a 409, not a silent overwrite of
     * each other's choice.
     */
    activateAssistantPrompt: {
      method: "POST",
      path: "/platform/assistant/prompts/:id/activate",
      pathParams: z24.object({ id: z24.string().uuid() }),
      body: z24.object({}).optional(),
      responses: { 200: platformAssistantPromptSchema, ...commonErrorResponses }
    },
    /** The operational knobs, as they stand. */
    getAssistantSettings: {
      method: "GET",
      path: "/platform/assistant/settings",
      responses: { 200: assistantSettingsSchema, ...commonErrorResponses }
    },
    /** Writes only the keys the caller sent; every other key is untouched. */
    updateAssistantSettings: {
      method: "PATCH",
      path: "/platform/assistant/settings",
      body: updateAssistantSettingsSchema,
      responses: { 200: assistantSettingsSchema, ...commonErrorResponses }
    },
    /**
     * What each agency has spent on the assistant this calendar month,
     * aggregated server-side the way M13's `agencyMetrics` is: the operator
     * learns a total, never a question or an answer.
     *
     * No `days` parameter, deliberately: this figure is read next to the
     * budget `AssistantRepository.monthlySpendCents` enforces, which is a
     * calendar-month-to-date sum, not a trailing window. A `?days=` here
     * would let the two silently disagree — near a month boundary a trailing
     * 30-day sum shows roughly twice, or roughly none, of what the loop is
     * actually checking against, which reads as a broken ceiling rather than
     * a mismeasured one. If a trend view is wanted later, it needs its own
     * route labelled as a trend, not a parameter on this one.
     */
    /**
     * The agency's own OpenRouter credential (M15.1). Operator only, like
     * everything else on this contract.
     *
     * `GET` answers a fingerprint and a date; `PUT` stores or rotates a key,
     * which is encrypted before it reaches a row and never returned;
     * `DELETE` clears it, which stops that agency's assistant answering at
     * the next question rather than mid-answer.
     */
    assistantCredential: {
      method: "GET",
      path: "/platform/agencies/:id/assistant-credential",
      responses: { 200: assistantCredentialStatusSchema, ...commonErrorResponses }
    },
    setAssistantCredential: {
      method: "PUT",
      path: "/platform/agencies/:id/assistant-credential",
      body: setAssistantCredentialSchema,
      responses: { 200: assistantCredentialStatusSchema, ...commonErrorResponses }
    },
    setAssistantBudget: {
      method: "PATCH",
      path: "/platform/agencies/:id/assistant-credential",
      body: setAssistantBudgetSchema,
      responses: { 200: assistantCredentialStatusSchema, ...commonErrorResponses }
    },
    clearAssistantCredential: {
      method: "DELETE",
      path: "/platform/agencies/:id/assistant-credential",
      responses: { 204: z24.null(), ...commonErrorResponses }
    },
    /**
     * The model registry (M15.2). Registering a model is what makes it
     * available to grant; the price comes from the public catalogue, so
     * registering one it does not list leaves it unpriced and unusable until
     * the next refresh finds it.
     */
    assistantModels: {
      method: "GET",
      path: "/platform/assistant/models",
      responses: { 200: z24.array(platformAssistantModelSchema), ...commonErrorResponses }
    },
    registerAssistantModel: {
      method: "PUT",
      path: "/platform/assistant/models",
      body: registerAssistantModelSchema,
      responses: { 200: platformAssistantModelSchema, ...commonErrorResponses }
    },
    refreshAssistantModels: {
      method: "POST",
      path: "/platform/assistant/models/refresh",
      body: z24.object({}),
      responses: { 200: z24.array(platformAssistantModelSchema), ...commonErrorResponses }
    },
    /** Which models an agency may use. Empty falls back to the global setting. */
    agencyAssistantModels: {
      method: "GET",
      path: "/platform/agencies/:id/assistant-models",
      responses: { 200: agencyAssistantModelsSchema, ...commonErrorResponses }
    },
    setAgencyAssistantModels: {
      method: "PUT",
      path: "/platform/agencies/:id/assistant-models",
      body: agencyAssistantModelsSchema,
      responses: { 200: agencyAssistantModelsSchema, ...commonErrorResponses }
    },
    assistantUsageReport: {
      method: "GET",
      path: "/platform/assistant/usage",
      responses: { 200: z24.array(platformAssistantUsageSchema), ...commonErrorResponses }
    },
    listAssistantReports: {
      method: "GET",
      path: "/platform/assistant/reports",
      responses: { 200: z24.array(platformAssistantReportSchema), ...commonErrorResponses }
    },
    assistantReport: {
      method: "GET",
      path: "/platform/assistant/reports/:id",
      pathParams: z24.object({ id: z24.string().uuid() }),
      responses: { 200: platformAssistantReportDetailSchema, ...commonErrorResponses }
    },
    closeAssistantReport: {
      method: "POST",
      path: "/platform/assistant/reports/:id/close",
      body: z24.object({}).optional(),
      responses: { 200: platformAssistantReportSchema, ...commonErrorResponses }
    },
    /**
     * the enquiries the public website collects (M16).
     *
     * Read, worked and deleted from here and nowhere else. `DELETE` is not a
     * tidying convenience: it is how an erasure request under GDPR is served,
     * and it is a real delete rather than a flag, because a flag is still the
     * personal data the subject asked to have removed.
     */
    listWebsiteLeads: {
      method: "GET",
      path: "/platform/website-leads",
      query: z24.object({
        kind: websiteLeadKindSchema.optional(),
        status: websiteLeadStatusSchema.optional(),
        q: z24.string().trim().max(200).optional()
      }),
      responses: { 200: z24.array(websiteLeadSchema), ...commonErrorResponses },
      summary: "Website enquiries, newest first."
    },
    updateWebsiteLead: {
      method: "PATCH",
      path: "/platform/website-leads/:id",
      pathParams: z24.object({ id: z24.string().uuid() }),
      body: websiteLeadUpdateSchema,
      responses: { 200: websiteLeadSchema, ...commonErrorResponses }
    },
    deleteWebsiteLead: {
      method: "DELETE",
      path: "/platform/website-leads/:id",
      pathParams: z24.object({ id: z24.string().uuid() }),
      responses: { 204: z24.null(), ...commonErrorResponses }
    }
  },
  { pathPrefix: "/api" }
);

// src/contracts/campaigns.contract.ts
import { initContract as initContract20 } from "@ts-rest/core";
import { z as z27 } from "zod";

// src/campaigns.ts
import { z as z26 } from "zod";

// src/segments.ts
import { z as z25 } from "zod";
var SEGMENT_FIELDS = [
  "kind",
  "classification",
  "comune_id",
  "has_channel",
  "consent",
  "created_after",
  "created_before"
];
var segmentFieldSchema = z25.enum(SEGMENT_FIELDS);
var SEGMENT_FIELD_LABELS = {
  kind: "Tipo di anagrafica",
  classification: "Classificazione",
  comune_id: "Comune",
  has_channel: "Ha un recapito",
  consent: "Consenso attivo",
  created_after: "Creato dopo il",
  created_before: "Creato prima del"
};
var SEGMENT_CONSENT_CHANNELS = [
  "email",
  "whatsapp"
];
var segmentConsentChannelSchema = consentChannelSchema.extract(SEGMENT_CONSENT_CHANNELS);
var segmentConditionSchema = z25.discriminatedUnion("field", [
  z25.object({ field: z25.literal("kind"), value: contactKindSchema }).strict(),
  z25.object({ field: z25.literal("classification"), value: contactClassificationSchema }).strict(),
  z25.object({ field: z25.literal("comune_id"), values: z25.array(z25.string().uuid()).min(1).max(200) }).strict(),
  z25.object({ field: z25.literal("has_channel"), value: contactChannelKindSchema }).strict(),
  z25.object({ field: z25.literal("consent"), value: segmentConsentChannelSchema }).strict(),
  z25.object({ field: z25.literal("created_after"), value: z25.string().datetime() }).strict(),
  z25.object({ field: z25.literal("created_before"), value: z25.string().datetime() }).strict()
]);
var segmentDefinitionSchema = z25.object({
  conditions: z25.array(segmentConditionSchema).min(1).max(20)
}).strict();

// src/campaigns.ts
var CAMPAIGN_CHANNELS = ["email", "whatsapp"];
var campaignChannelSchema = z26.enum(CAMPAIGN_CHANNELS);
var CAMPAIGN_CHANNEL_LABELS = {
  email: "Email",
  whatsapp: "WhatsApp"
};
var CAMPAIGN_STATUSES = ["draft", "running", "completed"];
var campaignStatusSchema = z26.enum(CAMPAIGN_STATUSES);
var CAMPAIGN_STATUS_LABELS = {
  draft: "Bozza",
  running: "In corso",
  completed: "Conclusa"
};
var segmentSchema = z26.object({
  id: z26.string().uuid(),
  name: z26.string(),
  definition: segmentDefinitionSchema,
  createdAt: z26.string().datetime(),
  updatedAt: z26.string().datetime()
});
var segmentInputSchema = z26.object({
  name: z26.string().trim().min(2).max(120),
  definition: segmentDefinitionSchema
}).strict();
var messageTemplateSchema = z26.object({
  id: z26.string().uuid(),
  name: z26.string(),
  channel: campaignChannelSchema,
  subject: z26.string().nullable(),
  body: z26.string(),
  createdAt: z26.string().datetime(),
  updatedAt: z26.string().datetime()
});
var MERGE_FIELDS = ["nome", "cognome", "agenzia"];
var MERGE_FIELD_PATTERN = /\{\{\s*([^{}]*?)\s*\}\}/g;
function unknownMergeFields(text) {
  const unknown = /* @__PURE__ */ new Set();
  for (const match of text.matchAll(MERGE_FIELD_PATTERN)) {
    const name = match[1] ?? "";
    if (!MERGE_FIELDS.includes(name)) unknown.add(name);
  }
  return [...unknown];
}
function applyMergeFields(text, values) {
  return text.replace(
    MERGE_FIELD_PATTERN,
    (whole, name) => MERGE_FIELDS.includes(name) ? values[name] : whole
  );
}
var messageTemplateInputSchema = z26.object({
  name: z26.string().trim().min(2).max(120),
  channel: campaignChannelSchema,
  subject: z26.string().trim().max(200).optional(),
  body: z26.string().trim().min(1).max(1e4)
}).strict().superRefine((value, context) => {
  if (value.channel === "email" && !value.subject) {
    context.addIssue({ code: "custom", path: ["subject"], message: "Indica un oggetto." });
  }
  if (value.channel === "whatsapp" && value.subject) {
    context.addIssue({
      code: "custom",
      path: ["subject"],
      message: "Un messaggio WhatsApp non ha oggetto."
    });
  }
  for (const [path, text] of [
    ["subject", value.subject ?? ""],
    ["body", value.body]
  ]) {
    const unknown = unknownMergeFields(text);
    if (unknown.length > 0) {
      context.addIssue({
        code: "custom",
        path: [path],
        message: `Campi non riconosciuti: ${unknown.map((name) => `{{${name}}}`).join(", ")}. Disponibili: ${MERGE_FIELDS.map((name) => `{{${name}}}`).join(", ")}.`
      });
    }
  }
});
var ENROLLMENT_STATUSES = ["active", "completed", "cancelled"];
var enrollmentStatusSchema = z26.enum(ENROLLMENT_STATUSES);
var MESSAGE_SEND_STATUSES = ["pending", "sending", "sent", "failed", "skipped"];
var messageSendStatusSchema = z26.enum(MESSAGE_SEND_STATUSES);
var CAMPAIGN_STEP_KINDS = ["send", "wait"];
var campaignStepKindSchema = z26.enum(CAMPAIGN_STEP_KINDS);
var campaignStepSchema = z26.object({
  id: z26.string().uuid(),
  position: z26.number().int().min(0),
  kind: campaignStepKindSchema,
  templateId: z26.string().uuid().nullable(),
  waitDays: z26.number().int().positive().nullable()
});
var campaignStepInputSchema = z26.discriminatedUnion("kind", [
  z26.object({ kind: z26.literal("send"), templateId: z26.string().uuid() }).strict(),
  z26.object({ kind: z26.literal("wait"), waitDays: z26.number().int().min(1).max(365) }).strict()
]);
var campaignSchema = z26.object({
  id: z26.string().uuid(),
  name: z26.string(),
  channel: campaignChannelSchema,
  segmentId: z26.string().uuid().nullable(),
  status: campaignStatusSchema,
  pausedAt: z26.string().datetime().nullable(),
  /** When a draft launches by itself (M10 / P3). Null once launched, or never scheduled. */
  scheduledAt: z26.string().datetime().nullable(),
  runCount: z26.number().int().min(0),
  steps: z26.array(campaignStepSchema),
  createdAt: z26.string().datetime(),
  updatedAt: z26.string().datetime()
});
var campaignInputSchema = z26.object({
  name: z26.string().trim().min(2).max(120),
  channel: campaignChannelSchema,
  segmentId: z26.string().uuid(),
  steps: z26.array(campaignStepInputSchema).min(1).max(20)
}).strict();

// src/contracts/campaigns.contract.ts
var c20 = initContract20();
var campaignDetailSchema = campaignSchema.extend({
  enrollments: z27.object({
    active: z27.number().int(),
    completed: z27.number().int(),
    cancelled: z27.number().int()
  }),
  delivery: z27.object({
    pending: z27.number().int(),
    sending: z27.number().int(),
    sent: z27.number().int(),
    failed: z27.number().int(),
    skipped: z27.number().int()
  }),
  events: z27.object({
    delivered: z27.number().int(),
    bounced: z27.number().int(),
    complained: z27.number().int(),
    unsubscribed: z27.number().int(),
    clicked: z27.number().int()
  })
});
var segmentPreviewSchema = z27.object({ total: z27.number().int() });
var campaignRecipientSchema = z27.object({
  id: z27.string().uuid(),
  contactId: z27.string().uuid(),
  contactName: z27.string(),
  status: enrollmentStatusSchema,
  stepIndex: z27.number().int(),
  dueAt: z27.string().datetime(),
  cancelledReason: z27.string(),
  sends: z27.number().int(),
  /** The newest copy for this person in this run, and why it stopped if it did (M10 / P3). */
  lastSend: z27.object({
    status: messageSendStatusSchema,
    reason: z27.string().nullable()
  }).nullable()
});
var campaignsContract = c20.router(
  {
    listSegments: {
      method: "GET",
      path: "/segments",
      query: listQuerySchema,
      responses: { 200: paginated(segmentSchema), ...commonErrorResponses },
      summary: "Saved audiences."
    },
    getSegment: {
      method: "GET",
      path: "/segments/:id",
      pathParams: z27.object({ id: z27.string().uuid() }),
      responses: { 200: segmentSchema, ...commonErrorResponses }
    },
    createSegment: {
      method: "POST",
      path: "/segments",
      body: segmentInputSchema,
      responses: { 201: segmentSchema, ...commonErrorResponses }
    },
    updateSegment: {
      method: "PATCH",
      path: "/segments/:id",
      pathParams: z27.object({ id: z27.string().uuid() }),
      body: segmentInputSchema,
      responses: { 200: segmentSchema, ...commonErrorResponses }
    },
    removeSegment: {
      method: "DELETE",
      path: "/segments/:id",
      pathParams: z27.object({ id: z27.string().uuid() }),
      responses: { 204: z27.null(), ...commonErrorResponses }
    },
    /**
     * How many contacts a definition resolves to, before it is saved.
     *
     * A POST because the definition is the question, not an identifier: it is
     * a structure, it can be long, and a query string is the wrong place for
     * the shape of somebody's audience.
     */
    previewSegment: {
      method: "POST",
      path: "/segments/preview",
      body: z27.object({ definition: segmentDefinitionSchema }),
      responses: { 200: segmentPreviewSchema, ...commonErrorResponses }
    },
    listTemplates: {
      method: "GET",
      path: "/message-templates",
      query: listQuerySchema,
      responses: { 200: paginated(messageTemplateSchema), ...commonErrorResponses }
    },
    getTemplate: {
      method: "GET",
      path: "/message-templates/:id",
      pathParams: z27.object({ id: z27.string().uuid() }),
      responses: { 200: messageTemplateSchema, ...commonErrorResponses }
    },
    createTemplate: {
      method: "POST",
      path: "/message-templates",
      body: messageTemplateInputSchema,
      responses: { 201: messageTemplateSchema, ...commonErrorResponses }
    },
    updateTemplate: {
      method: "PATCH",
      path: "/message-templates/:id",
      pathParams: z27.object({ id: z27.string().uuid() }),
      body: messageTemplateInputSchema,
      responses: { 200: messageTemplateSchema, ...commonErrorResponses }
    },
    removeTemplate: {
      method: "DELETE",
      path: "/message-templates/:id",
      pathParams: z27.object({ id: z27.string().uuid() }),
      responses: { 204: z27.null(), ...commonErrorResponses }
    },
    listCampaigns: {
      method: "GET",
      path: "/campaigns",
      query: listQuerySchema,
      responses: { 200: paginated(campaignSchema), ...commonErrorResponses }
    },
    getCampaign: {
      method: "GET",
      path: "/campaigns/:id",
      pathParams: z27.object({ id: z27.string().uuid() }),
      responses: { 200: campaignDetailSchema, ...commonErrorResponses }
    },
    createCampaign: {
      method: "POST",
      path: "/campaigns",
      body: campaignInputSchema,
      responses: { 201: campaignSchema, ...commonErrorResponses }
    },
    updateCampaign: {
      method: "PATCH",
      path: "/campaigns/:id",
      pathParams: z27.object({ id: z27.string().uuid() }),
      body: campaignInputSchema,
      responses: { 200: campaignSchema, ...commonErrorResponses }
    },
    removeCampaign: {
      method: "DELETE",
      path: "/campaigns/:id",
      pathParams: z27.object({ id: z27.string().uuid() }),
      responses: { 204: z27.null(), ...commonErrorResponses }
    },
    /**
     * Starts a run: the audience is resolved as it stands now and everybody in
     * it is enrolled at step zero. The tick that follows materialises sends and,
     * for email, delivers them (M10 / P3); a WhatsApp campaign is refused.
     */
    launchCampaign: {
      method: "POST",
      path: "/campaigns/:id/launch",
      pathParams: z27.object({ id: z27.string().uuid() }),
      body: z27.object({}).optional(),
      responses: {
        200: z27.object({
          run: z27.number().int(),
          enrolled: z27.number().int(),
          audience: z27.number().int()
        }),
        ...commonErrorResponses
      }
    },
    /** Who is in the campaign, where they got to, and what was prepared. */
    listCampaignRecipients: {
      method: "GET",
      path: "/campaigns/:id/recipients",
      pathParams: z27.object({ id: z27.string().uuid() }),
      query: listQuerySchema,
      responses: { 200: paginated(campaignRecipientSchema), ...commonErrorResponses }
    },
    /**
     * Pausing leaves every enrollment where it is and the tick skips the
     * campaign. Resuming does not shift due dates forward: a wait that elapsed
     * during the pause is over, not restarted.
     */
    /**
     * Sets or clears the moment a draft launches by itself (M10 / P3). A launch
     * at that moment is the same launch as the button's, with the same checks
     * — made then, not now.
     */
    scheduleCampaign: {
      method: "POST",
      path: "/campaigns/:id/schedule",
      pathParams: z27.object({ id: z27.string().uuid() }),
      body: z27.object({ scheduledAt: z27.string().datetime().nullable() }).strict(),
      responses: { 200: campaignDetailSchema, ...commonErrorResponses }
    },
    /** A new draft with the same name, audience and sequence: the next issue of a newsletter. */
    duplicateCampaign: {
      method: "POST",
      path: "/campaigns/:id/duplicate",
      pathParams: z27.object({ id: z27.string().uuid() }),
      body: z27.object({}).optional(),
      responses: { 201: campaignSchema, ...commonErrorResponses }
    },
    pauseCampaign: {
      method: "POST",
      path: "/campaigns/:id/pause",
      pathParams: z27.object({ id: z27.string().uuid() }),
      body: z27.object({ paused: z27.boolean() }),
      responses: { 200: campaignDetailSchema, ...commonErrorResponses }
    }
  },
  { pathPrefix: "/api" }
);

// src/contracts/email.contract.ts
import { initContract as initContract21 } from "@ts-rest/core";
import { z as z29 } from "zod";

// src/email.ts
import { z as z28 } from "zod";
var EMAIL_OPTIN_SOURCE_KINDS = [
  "in_agency",
  "paper_form",
  "phone",
  "website",
  "other"
];
var emailOptinSourceKindSchema = z28.enum(EMAIL_OPTIN_SOURCE_KINDS);
var EMAIL_OPTIN_SOURCE_LABELS = {
  in_agency: "In agenzia",
  paper_form: "Modulo cartaceo",
  phone: "Al telefono",
  website: "Dal sito",
  other: "Altro"
};
var emailOptinInputSchema = z28.object({
  address: z28.string().trim().toLowerCase().email().max(254),
  sourceKind: emailOptinSourceKindSchema,
  sourceNote: z28.string().trim().max(500).default("")
}).strict().superRefine((value, context) => {
  if (value.sourceKind === "other" && !value.sourceNote) {
    context.addIssue({
      code: "custom",
      path: ["sourceNote"],
      message: "Indica dove il contatto ha chiesto di ricevere le comunicazioni."
    });
  }
});
var EMAIL_SUPPRESSION_REASONS = ["bounce", "complaint"];
var MESSAGE_EVENT_TYPES = [
  "delivered",
  "bounced",
  "complained",
  "clicked",
  "unsubscribed"
];
var contactEmailStatusSchema = z28.object({
  consent: z28.object({
    granted: z28.boolean(),
    grantedAt: z28.string().datetime().nullable(),
    revokedAt: z28.string().datetime().nullable(),
    source: z28.string().nullable()
  }),
  addresses: z28.array(
    z28.object({
      address: z28.string(),
      isPrimary: z28.boolean(),
      suppressed: z28.enum(EMAIL_SUPPRESSION_REASONS).nullable()
    })
  ),
  openRequests: z28.array(
    z28.object({
      id: z28.string().uuid(),
      address: z28.string(),
      sourceKind: emailOptinSourceKindSchema,
      sourceNote: z28.string(),
      createdAt: z28.string().datetime(),
      expiresAt: z28.string().datetime(),
      expired: z28.boolean()
    })
  ),
  lastConfirmed: z28.object({
    address: z28.string(),
    sourceKind: emailOptinSourceKindSchema,
    confirmedAt: z28.string().datetime()
  }).nullable()
});
var SENDING_DOMAIN_STATUSES = ["pending", "verified", "failed"];
var SENDING_DOMAIN_STATUS_LABELS = {
  pending: "In attesa dei record DNS",
  verified: "Verificato",
  failed: "Non verificato"
};
var PUBLIC_MAIL_DOMAINS = [
  "gmail.com",
  "googlemail.com",
  "outlook.com",
  "outlook.it",
  "hotmail.com",
  "hotmail.it",
  "live.com",
  "live.it",
  "yahoo.com",
  "yahoo.it",
  "icloud.com",
  "me.com",
  "libero.it",
  "virgilio.it",
  "alice.it",
  "tim.it",
  "tin.it",
  "fastwebnet.it",
  "tiscali.it",
  "aruba.it",
  "pec.it",
  "legalmail.it"
];
var HOSTNAME = /^(?=.{4,253}$)(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,63}$/;
var sendingDomainInputSchema = z28.object({
  domain: z28.string().trim().toLowerCase().transform((value) => value.replace(/\.$/, "")).refine((value) => HOSTNAME.test(value), "Indica un dominio, per esempio agenzia.it.").refine(
    (value) => !PUBLIC_MAIL_DOMAINS.includes(value),
    "Serve un dominio dell\u2019agenzia: quelli dei provider di posta non si possono verificare."
  ),
  fromLocalPart: z28.string().trim().toLowerCase().regex(/^[a-z0-9](?:[a-z0-9._-]{0,62}[a-z0-9])?$/, "Solo lettere, numeri, punto, trattino.").default("newsletter")
}).strict();
var dnsRecordSchema = z28.object({
  type: z28.enum(["CNAME", "TXT"]),
  name: z28.string(),
  value: z28.string()
});
var sendingDomainOverviewSchema = z28.object({
  domain: z28.object({
    domain: z28.string(),
    fromLocalPart: z28.string(),
    status: z28.enum(SENDING_DOMAIN_STATUSES),
    dkimRecords: z28.array(dnsRecordSchema),
    dmarcRecord: dnsRecordSchema,
    lastCheckedAt: z28.string().datetime().nullable(),
    verifiedAt: z28.string().datetime().nullable()
  }).nullable(),
  senderInEffect: z28.string(),
  platformSender: z28.string()
});

// src/contracts/email.contract.ts
var c21 = initContract21();
var emailContract = c21.router(
  {
    getContactEmailStatus: {
      method: "GET",
      path: "/contacts/:id/email-status",
      pathParams: z29.object({ id: z29.string().uuid() }),
      responses: { 200: contactEmailStatusSchema, ...commonErrorResponses },
      summary: "A contact's email consent, addresses and open confirmation requests."
    },
    requestEmailOptin: {
      method: "POST",
      path: "/contacts/:id/email-optin",
      pathParams: z29.object({ id: z29.string().uuid() }),
      body: emailOptinInputSchema,
      responses: { 201: contactEmailStatusSchema, ...commonErrorResponses },
      summary: "Records where the contact asked to receive email, and sends them the confirmation link."
    },
    getSendingDomain: {
      method: "GET",
      path: "/agency/sending-domain",
      responses: { 200: sendingDomainOverviewSchema, ...commonErrorResponses },
      summary: "The agency\u2019s own sending domain, its DNS records, and the sender in effect."
    },
    setSendingDomain: {
      method: "PUT",
      path: "/agency/sending-domain",
      body: sendingDomainInputSchema,
      responses: { 200: sendingDomainOverviewSchema, ...commonErrorResponses }
    },
    verifySendingDomain: {
      method: "POST",
      path: "/agency/sending-domain/verify",
      body: z29.object({}).strict(),
      responses: { 200: sendingDomainOverviewSchema, ...commonErrorResponses }
    },
    removeSendingDomain: {
      method: "DELETE",
      path: "/agency/sending-domain",
      responses: { 200: sendingDomainOverviewSchema, ...commonErrorResponses }
    }
  },
  { pathPrefix: "/api" }
);
var platformEmailContract = c21.router(
  {
    getAgencySendingDomain: {
      method: "GET",
      path: "/platform/agencies/:id/sending-domain",
      pathParams: z29.object({ id: z29.string().uuid() }),
      responses: { 200: sendingDomainOverviewSchema, ...commonErrorResponses }
    },
    setAgencySendingDomain: {
      method: "PUT",
      path: "/platform/agencies/:id/sending-domain",
      pathParams: z29.object({ id: z29.string().uuid() }),
      body: sendingDomainInputSchema,
      responses: { 200: sendingDomainOverviewSchema, ...commonErrorResponses }
    },
    verifyAgencySendingDomain: {
      method: "POST",
      path: "/platform/agencies/:id/sending-domain/verify",
      pathParams: z29.object({ id: z29.string().uuid() }),
      body: z29.object({}).strict(),
      responses: { 200: sendingDomainOverviewSchema, ...commonErrorResponses }
    },
    removeAgencySendingDomain: {
      method: "DELETE",
      path: "/platform/agencies/:id/sending-domain",
      pathParams: z29.object({ id: z29.string().uuid() }),
      responses: { 200: sendingDomainOverviewSchema, ...commonErrorResponses }
    }
  },
  { pathPrefix: "/api" }
);

// src/contracts/references.contract.ts
import { initContract as initContract22 } from "@ts-rest/core";
import { z as z30 } from "zod";
var c22 = initContract22();
var referenceHitSchema = z30.object({
  reference: z30.string(),
  type: z30.enum(["mandate", "property", "contact", "demand", "building", "activity"]),
  id: z30.string().uuid(),
  /**
   * Enough to show in a result row without a second call. Empty when the entity
   * has no name of its own: a property is known by its address and a demand by
   * who asked, both a join away and both on the screen the code opens.
   */
  label: z30.string()
});
var referencesContract = c22.router(
  {
    resolve: {
      method: "GET",
      path: "/references/:reference",
      pathParams: z30.object({ reference: z30.string().min(1).max(40) }),
      responses: {
        200: referenceHitSchema,
        ...commonErrorResponses
      },
      summary: "The record a code names, or 404 \u2014 including for a code that fails its check."
    }
  },
  { pathPrefix: "/api" }
);

// src/contracts/whatsapp.contract.ts
import { initContract as initContract23 } from "@ts-rest/core";
import { z as z31 } from "zod";
var c23 = initContract23();
var whatsappQrSchema = z31.object({
  /** A PNG data URI. The screen renders it; nobody reads the payload. */
  image: z31.string().nullable(),
  /** A QR is short-lived, and the screen says so rather than showing a dead one. */
  expiresAt: z31.string().datetime()
});
var whatsappHistorySchema = z31.object({
  available: z31.boolean(),
  mode: whatsappHistoryModeSchema,
  windowMonths: whatsappHistoryWindowSchema.nullable(),
  state: whatsappHistoryStateSchema,
  /** Messages copied so far. What the progress on the screen counts. */
  imported: z31.number().int(),
  /**
   * Copied messages whose attachment could not be brought.
   *
   * Said in the interface rather than hidden: the references WhatsApp hands
   * over with an old message expired long before we saw them, and a thread that
   * quietly lacks a photograph is worse than one that says so.
   */
  attachmentsMissing: z31.number().int(),
  startedAt: z31.string().datetime().nullable()
});
var whatsappHistoryChoiceSchema = z31.object({
  mode: whatsappHistoryModeSchema,
  /** Required by `full`, meaningless otherwise. */
  windowMonths: whatsappHistoryWindowSchema.nullable().optional()
});
var whatsappStoredSchema = z31.object({
  conversations: z31.number().int(),
  messages: z31.number().int()
});
var whatsappAccountSchema = z31.object({
  /** Null until an agency has ever connected: the screen then offers to start. */
  state: whatsappConnectionStateSchema.nullable(),
  phoneNumber: z31.string().nullable(),
  connectedAt: z31.string().datetime().nullable(),
  qr: whatsappQrSchema.nullable(),
  capabilities: whatsappCapabilitiesSchema,
  history: whatsappHistorySchema,
  stored: whatsappStoredSchema
});
var conversationSchema = z31.object({
  id: z31.string().uuid(),
  state: conversationStateSchema,
  contactId: z31.string().uuid().nullable(),
  /** The contact's name, or the number, when nobody has named them yet. */
  contactName: z31.string(),
  phoneNumber: z31.string().nullable(),
  unreadCount: z31.number().int(),
  lastMessageAt: z31.string().datetime().nullable(),
  /**
   * The last message in the thread, whoever sent it — enough of it to write one
   * line in the list (M8.1).
   *
   * Not a string: a photograph has no text, a voice note has neither text nor
   * file name, and a list that previewed only `body` showed those as blank rows.
   * What to call each kind is the interface's decision, so it gets the facts.
   */
  lastMessage: z31.object({
    type: messageTypeSchema,
    body: z31.string().nullable(),
    fileName: z31.string().nullable(),
    voice: z31.boolean(),
    durationSeconds: z31.number().int().nullable(),
    fromMe: z31.boolean()
  }).nullable(),
  assignedUserId: z31.string().uuid().nullable(),
  assignedUserName: z31.string().nullable()
});
var messageSchema = z31.object({
  id: z31.string().uuid(),
  direction: messageDirectionSchema,
  type: messageTypeSchema,
  body: z31.string().nullable(),
  status: z31.string(),
  mediaState: messageMediaStateSchema,
  mediaUrl: z31.string().nullable(),
  mediaMimeType: z31.string().nullable(),
  mediaFileName: z31.string().nullable(),
  mediaSize: z31.number().int().nullable(),
  /** Seconds, for what is played rather than opened (M8.1). */
  mediaDurationSeconds: z31.number().int().nullable(),
  /** A voice note: drawn as a microphone and a length, never as a file. */
  mediaVoice: z31.boolean(),
  sentByUserId: z31.string().uuid().nullable(),
  sentByUserName: z31.string().nullable(),
  occurredAt: z31.string().datetime()
});
var sendMessageSchema = z31.object({
  body: z31.string().trim().max(4096).optional(),
  mediaPath: z31.string().min(1).optional(),
  mediaFileName: z31.string().min(1).optional(),
  mediaMimeType: z31.string().min(1).optional()
}).refine((value) => Boolean(value.body) || Boolean(value.mediaPath), {
  message: "Scrivi un messaggio o allega un file."
}).refine((value) => !value.mediaPath || value.mediaFileName && value.mediaMimeType, {
  message: "Un allegato ha bisogno di nome e tipo di file."
});
var WHATSAPP_UPLOAD_TYPES = /^(image\/(jpeg|png|webp|gif)|video\/mp4|audio\/(mpeg|ogg|mp4|aac)|application\/(pdf|msword|vnd\.openxmlformats-officedocument\.(wordprocessingml\.document|spreadsheetml\.sheet)))$/;
var whatsappUploadTicketRequestSchema = z31.object({
  fileName: z31.string().trim().min(1).max(255),
  contentType: z31.string().trim().regex(WHATSAPP_UPLOAD_TYPES, "Tipo di file non consentito"),
  sizeBytes: z31.number().int().min(1)
});
var whatsappUploadTicketSchema = z31.object({
  /** PUT the bytes here, with the same Content-Type. */
  uploadUrl: z31.string(),
  /** Sent back as `mediaPath` when the message is posted. */
  path: z31.string(),
  expiresInSeconds: z31.number().int()
});
var whatsappContract = c23.router(
  {
    uploadTicket: {
      method: "POST",
      path: "/whatsapp/uploads",
      body: whatsappUploadTicketRequestSchema,
      // The browser PUTs the bytes straight to storage, as it does for property
      // photographs: a twenty-megabyte video has no business crossing the API
      // twice. The API reads it back only when handing it to the runtime, which
      // is what keeps our bucket private.
      responses: { 201: whatsappUploadTicketSchema, ...commonErrorResponses },
      summary: "A ticket for uploading an attachment before sending it."
    },
    conversations: {
      method: "GET",
      path: "/whatsapp/conversations",
      query: listQuerySchema.extend({
        state: conversationStateSchema.optional(),
        /** Only what nobody has answered yet — the inbox's default view. */
        unread: z31.enum(["true", "false"]).optional()
      }),
      responses: { 200: paginated(conversationSchema), ...commonErrorResponses },
      summary: "The agency's WhatsApp threads, newest activity first."
    },
    thread: {
      method: "GET",
      path: "/whatsapp/conversations/:id/messages",
      pathParams: z31.object({ id: z31.string().uuid() }),
      query: listQuerySchema,
      responses: { 200: paginated(messageSchema), ...commonErrorResponses },
      summary: "The messages in one thread, oldest first."
    },
    /*
     * `GET /api/whatsapp/conversations/:id/avatar` is deliberately not here.
     *
     * It answers with `image/jpeg`, not JSON, and it is consumed by an `<img>`
     * rather than by this client — so it lives as a plain route on the
     * controller (M8.1). Handing the browser the provider's URL, which is what
     * this contract used to do, made every opened thread a request to Meta from
     * the agency's own address.
     */
    send: {
      method: "POST",
      path: "/whatsapp/conversations/:id/messages",
      pathParams: z31.object({ id: z31.string().uuid() }),
      body: sendMessageSchema,
      responses: { 201: messageSchema, ...commonErrorResponses },
      summary: "Reply in a thread."
    },
    markRead: {
      method: "POST",
      path: "/whatsapp/conversations/:id/read",
      pathParams: z31.object({ id: z31.string().uuid() }),
      body: z31.object({}),
      // Reading is an act by a person, not a side effect of a GET: two agents
      // with the same thread open must not clear each other's badge by looking.
      responses: { 200: conversationSchema, ...commonErrorResponses },
      summary: "Clear the unread count on a thread."
    },
    get: {
      method: "GET",
      path: "/whatsapp/account",
      // Reads through to the runtime, so a session that dropped while nobody
      // was looking is visible the moment the screen opens rather than after
      // the next inbound message fails to arrive.
      responses: { 200: whatsappAccountSchema, ...commonErrorResponses },
      summary: "The agency's WhatsApp connection."
    },
    connect: {
      method: "POST",
      path: "/whatsapp/account/connect",
      // The history choice travels with the first call and is refused on a
      // connection that already exists (M8.1): the runtime reads it when the
      // phone scans, so changing it costs a disconnect and a second scan. Absent
      // means 'none', which is what every M8 connection chose by existing.
      body: z31.object({ history: whatsappHistoryChoiceSchema.optional() }),
      // Idempotent: called once to create the connection and again for every
      // fresh QR, because a code expires while the manager looks for the phone.
      responses: { 200: whatsappAccountSchema, ...commonErrorResponses },
      summary: "Start or resume connecting the number, returning a QR to scan."
    },
    disconnect: {
      method: "POST",
      path: "/whatsapp/account/disconnect",
      body: z31.object({}),
      // Ends the WhatsApp session and keeps the connection: re-scanning resumes
      // the same conversations, which is why this is not a delete.
      responses: { 200: whatsappAccountSchema, ...commonErrorResponses },
      summary: "Log the number out, keeping its history."
    },
    removeData: {
      method: "DELETE",
      path: "/whatsapp/data",
      // Everything WhatsApp left here, live and imported alike (M8.1). The
      // contacts stay, and so does the timeline: how somebody came to exist is
      // a fact about them, not a copy of what they said.
      responses: { 200: whatsappAccountSchema, ...commonErrorResponses },
      summary: "Remove every WhatsApp conversation and message the agency holds."
    },
    removeHistory: {
      method: "DELETE",
      path: "/whatsapp/account/history",
      // Undoing an import, and nothing else: one statement on `source`, which
      // cannot reach a message somebody actually sent us (M8.1). The contacts
      // stay — an agency that has since worked with one did not ask to lose it.
      responses: { 200: whatsappAccountSchema, ...commonErrorResponses },
      summary: "Remove the conversations an import copied."
    },
    remove: {
      method: "DELETE",
      path: "/whatsapp/account",
      // The conversations stay. They are ours, and an agency that disconnects a
      // number has not asked to lose what its customers said.
      responses: { 200: whatsappAccountSchema, ...commonErrorResponses },
      summary: "Remove the connection entirely."
    }
  },
  { pathPrefix: "/api" }
);

// src/validation/phone.ts
var DEFAULT_COUNTRY_CODE = "39";
function normalizePhone(value) {
  const trimmed = value.trim();
  if (!trimmed) return null;
  const international = trimmed.startsWith("+") || trimmed.startsWith("00");
  const digits = trimmed.replace(/\D/g, "").replace(/^00/, "");
  if (digits.length < 6) return null;
  if (international) return digits;
  if (digits.startsWith(DEFAULT_COUNTRY_CODE) && digits.length > 10) return digits;
  return `${DEFAULT_COUNTRY_CODE}${digits}`;
}
function phoneMatchKey(value) {
  const normalized = normalizePhone(value);
  if (!normalized) return null;
  return normalized.slice(-9);
}

// src/product-events.ts
var PRODUCT_EVENTS = [
  "session.signed_in",
  "property.created",
  "contact.created",
  "mandate.created",
  "demand.created",
  "activity.created",
  "matching.viewed",
  "assistant.question_asked",
  "whatsapp.message_sent",
  "campaign.launched"
];
var PRODUCT_EVENT_LABELS = {
  "session.signed_in": "Accessi",
  "property.created": "Immobili creati",
  "contact.created": "Contatti creati",
  "mandate.created": "Incarichi creati",
  "demand.created": "Richieste create",
  "activity.created": "Attivit\xE0 registrate",
  "matching.viewed": "Matching consultati",
  "assistant.question_asked": "Domande all\u2019assistente",
  "whatsapp.message_sent": "Messaggi WhatsApp",
  "campaign.launched": "Campagne lanciate"
};
function summarizeFeatureUsage(rows) {
  const latestDay = rows.reduce(
    (latest, row) => latest === null || row.day > latest ? row.day : latest,
    null
  );
  const retired = [
    ...new Set(
      rows.map((row) => row.name).filter((name) => !PRODUCT_EVENTS.includes(name))
    )
  ].sort();
  return [...PRODUCT_EVENTS, ...retired].map((name) => {
    const own = rows.filter((row) => row.name === name);
    const onLatest = own.find((row) => row.day === latestDay);
    return {
      name,
      label: PRODUCT_EVENT_LABELS[name] ?? name,
      total: own.reduce((sum, row) => sum + row.count, 0),
      latest: onLatest?.count ?? 0,
      users30d: onLatest?.users30d ?? 0
    };
  });
}

// src/zoned-time.ts
function zonedLocalToUtc(local, timeZone) {
  const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/.exec(local);
  if (!match) throw new Error(`not a local date-time: ${local}`);
  const [, y, mo, d, h, mi] = match.map(Number);
  const wall = Date.UTC(y, mo - 1, d, h, mi);
  let instant = wall;
  for (let pass = 0; pass < 2; pass += 1) {
    instant = wall - offsetAt(instant, timeZone);
  }
  return new Date(instant).toISOString();
}
function utcToZonedLocal(iso, timeZone) {
  const parts = partsAt(new Date(iso).getTime(), timeZone);
  const pad = (value) => String(value).padStart(2, "0");
  return `${parts.year}-${pad(parts.month)}-${pad(parts.day)}T${pad(parts.hour)}:${pad(parts.minute)}`;
}
function offsetAt(instant, timeZone) {
  const parts = partsAt(instant, timeZone);
  const asUtc = Date.UTC(
    parts.year,
    parts.month - 1,
    parts.day,
    parts.hour,
    parts.minute,
    parts.second
  );
  return asUtc - Math.floor(instant / 1e3) * 1e3;
}
var formatters = /* @__PURE__ */ new Map();
function formatterFor(timeZone) {
  let formatter = formatters.get(timeZone);
  if (!formatter) {
    formatter = new Intl.DateTimeFormat("en-GB", {
      timeZone,
      hourCycle: "h23",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
    formatters.set(timeZone, formatter);
  }
  return formatter;
}
function partsAt(instant, timeZone) {
  const values = {};
  for (const part of formatterFor(timeZone).formatToParts(new Date(instant))) {
    if (part.type !== "literal") values[part.type] = Number(part.value);
  }
  return values;
}

// src/slug.ts
function slugify(name) {
  return name.normalize("NFD").replace(/\p{Diacritic}/gu, "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "").slice(0, 40).replace(/-+$/g, "");
}
function freeSlug(name, taken) {
  const base = slugify(name) || "agenzia";
  const used = new Set(taken);
  if (!used.has(base)) return base;
  for (let n = 1; ; n += 1) {
    const suffix = `-${n}`;
    const candidate = `${base.slice(0, 40 - suffix.length).replace(/-+$/g, "")}${suffix}`;
    if (!used.has(candidate)) return candidate;
  }
}

// src/reference.ts
var REFERENCE_ALPHABET = "0123456789ABCDEFGHJKLMNPQRSTUVWXYZ";
var REFERENCE_TYPES = {
  mandate: "IN",
  property: "IM",
  contact: "CT",
  demand: "RC",
  building: "ED",
  activity: "AT"
};
var TYPE_BY_CODE = new Map(
  Object.entries(REFERENCE_TYPES).map(([type, code]) => [code, type])
);
function mod97(payload) {
  let remainder = 0;
  for (const char of payload) {
    const value = REFERENCE_ALPHABET.indexOf(char);
    if (value === -1) continue;
    remainder = (remainder * (value > 9 ? 100 : 10) + value) % 97;
  }
  return remainder;
}
function checkDigits(payload) {
  return String(98 - mod97(payload) * 100 % 97).padStart(2, "0");
}
function normaliseReference(input) {
  return input.toUpperCase().replace(/[^0-9A-Z]/g, "");
}
function correct(group) {
  return group.replace(/I/g, "1").replace(/O/g, "0");
}
function formatReference(parts) {
  const typeCode = REFERENCE_TYPES[parts.type];
  const sequence = String(parts.sequence).padStart(4, "0");
  const payload = correct(`${parts.agencyCode}${typeCode}${sequence}`);
  return `${parts.agencyCode}-${typeCode}-${sequence}-${checkDigits(payload)}`;
}
function parseReference(input) {
  const normalised = normaliseReference(input);
  const match = /^([0-9A-Z]{3})([0-9A-Z]{2})([0-9A-Z]{4,})([0-9]{2})$/.exec(normalised);
  if (!match) return null;
  const [, rawAgency, rawType, rawSequence, check] = match;
  const agencyCode2 = correct(rawAgency);
  const sequence = correct(rawSequence);
  if (!/^[0-9]+$/.test(sequence)) return null;
  const type = TYPE_BY_CODE.get(rawType) ?? TYPE_BY_CODE.get(rawType.replace(/1/g, "I").replace(/0/g, "O"));
  if (!type) return null;
  const typeCode = REFERENCE_TYPES[type];
  if (checkDigits(correct(`${agencyCode2}${typeCode}${sequence}`)) !== check) return null;
  return { agencyCode: agencyCode2, type, sequence: Number(sequence) };
}
function looksLikeReference(input) {
  return /^[0-9A-Z]{3}[0-9A-Z]{2}[0-9A-Z]{6,}$/.test(normaliseReference(input));
}
function agencyCode(name, taken = []) {
  const cleaned = name.normalize("NFD").replace(/\p{Diacritic}/gu, "").toUpperCase().replace(/I/g, "1").replace(/O/g, "0").replace(/[^0-9A-Z]/g, "");
  const consonants = cleaned.replace(/[AEU10]/g, "");
  const base = `${consonants}${cleaned}XXX`.slice(0, 3);
  const used = new Set(taken);
  if (!used.has(base)) return base;
  for (const char of REFERENCE_ALPHABET) {
    const candidate = `${base.slice(0, 2)}${char}`;
    if (!used.has(candidate)) return candidate;
  }
  throw new Error(`No agency code left for ${name}`);
}

// src/index.ts
var c24 = initContract24();
var contract = c24.router({
  health: healthContract,
  auth: authContract,
  geo: geoContract,
  zones: zonesContract,
  propertyTypologies: propertyTypologiesContract,
  appointmentTypes: appointmentTypesContract,
  contacts: contactsContract,
  buildings: buildingsContract,
  properties: propertiesContract,
  mandates: mandatesContract,
  demands: demandsContract,
  propertyMatches: propertyMatchesContract,
  activities: activitiesContract,
  users: usersContract,
  dashboard: dashboardContract,
  geocoding: geocodingContract,
  zoneCatalog: zoneCatalogContract,
  agency: agencyContract,
  platform: platformContract,
  references: referencesContract,
  whatsapp: whatsappContract,
  // Segments, message templates and campaigns (M9 / P2). Nothing here
  // delivers: a launch enrolls, the tick materialises sends, and they stop at
  // pending until P3 binds a channel.
  campaigns: campaignsContract,
  // Email consent, delivery and sending domains (M10 / P3). The links inside
  // an email are served outside ts-rest: they answer a mail client, not the app.
  email: emailContract,
  platformEmail: platformEmailContract,
  // The session sidebar only. The streaming endpoint is served outside
  // ts-rest — see the module's own comment (M15).
  assistant: assistantContract
});
export {
  ACTIVITY_SUBJECTS,
  ACTIVITY_SUBJECT_LABELS,
  ACTIVITY_TYPES,
  ACTIVITY_TYPE_LABELS,
  AGENCY_DELETION_STATUSES,
  AGENCY_ROLES,
  AGENCY_ROLE_LABELS,
  APPOINTMENT_OUTCOMES,
  APPOINTMENT_OUTCOME_LABELS,
  ASSISTANT_REPORT_STATUSES,
  CALL_OUTCOMES,
  CALL_OUTCOME_LABELS,
  CAMPAIGN_CHANNELS,
  CAMPAIGN_CHANNEL_LABELS,
  CAMPAIGN_STATUSES,
  CAMPAIGN_STATUS_LABELS,
  CAMPAIGN_STEP_KINDS,
  CONSENT_CHANNELS,
  CONSENT_CHANNEL_LABELS,
  CONSENT_LEGAL_BASES,
  CONTACT_CHANNEL_KINDS,
  CONTACT_CHANNEL_KIND_LABELS,
  CONTACT_CLASSIFICATIONS,
  CONTACT_CLASSIFICATION_LABELS,
  CONTACT_KINDS,
  CONTACT_KIND_LABELS,
  CONTACT_RELATION_INVERSE,
  CONTACT_RELATION_TYPES,
  CONTACT_RELATION_TYPE_LABELS,
  CONTACT_SOURCES,
  CONTRACT_TYPES,
  CONTRACT_TYPE_LABELS,
  CONVERSATION_STATES,
  CONVERSATION_STATE_LABELS,
  DEFAULT_PAGE_SIZE,
  DEFAULT_ZONE_TIERS,
  DEMAND_STATUSES,
  DEMAND_STATUS_LABELS,
  DERIVED_ROLES,
  DERIVED_ROLE_LABELS,
  EMAIL_OPTIN_SOURCE_KINDS,
  EMAIL_OPTIN_SOURCE_LABELS,
  EMAIL_SUPPRESSION_REASONS,
  ENERGY_CLASSES,
  ENROLLMENT_STATUSES,
  EXPOSURES,
  EXPOSURE_LABELS,
  EXTERIOR_CONDITIONS,
  EXTERIOR_CONDITION_LABELS,
  FLOOR_LEVELS,
  FLOOR_LEVEL_LABELS,
  GARAGE_TYPES,
  GARAGE_TYPE_LABELS,
  GARDEN_TYPES,
  GARDEN_TYPE_LABELS,
  HEATINGS,
  HEATING_LABELS,
  INTERIOR_CONDITIONS,
  INTERIOR_CONDITION_LABELS,
  MANDATE_ACTIONS,
  MANDATE_ACTION_LABELS,
  MANDATE_STATUSES,
  MANDATE_STATUS_LABELS,
  MANDATE_TRANSITIONS,
  MAX_PAGE_SIZE,
  MEDIA_ROLES,
  MEDIA_ROLE_LABELS,
  MERGE_FIELDS,
  MESSAGE_DIRECTIONS,
  MESSAGE_EVENT_TYPES,
  MESSAGE_MEDIA_STATES,
  MESSAGE_SEND_STATUSES,
  MESSAGE_SOURCES,
  MESSAGE_TYPES,
  OCCUPIED_BY,
  OCCUPIED_BY_LABELS,
  OWNERSHIP_TYPES,
  OWNERSHIP_TYPE_LABELS,
  PLATFORM_ROLE,
  PRODUCT_EVENTS,
  PRODUCT_EVENT_LABELS,
  PROPERTY_KNOWN_ATTRIBUTES,
  PROPERTY_KNOWN_ATTRIBUTE_KEYS,
  PROPERTY_STATUSES,
  PROPERTY_STATUS_LABELS,
  PROPERTY_USES,
  PROPERTY_USE_LABELS,
  PUBLIC_MAIL_DOMAINS,
  REFERENCE_ALPHABET,
  REFERENCE_TYPES,
  REMINDER_DUE_STATES,
  REMINDER_DUE_STATE_LABELS,
  ROLE_RANK,
  SEGMENT_CONSENT_CHANNELS,
  SEGMENT_FIELDS,
  SEGMENT_FIELD_LABELS,
  SENDING_DOMAIN_STATUSES,
  SENDING_DOMAIN_STATUS_LABELS,
  TYPOLOGY_LEVELS,
  TYPOLOGY_LEVEL_LABELS,
  WEBSITE_LEAD_KINDS,
  WEBSITE_LEAD_KIND_LABELS,
  WEBSITE_LEAD_STATUSES,
  WEBSITE_LEAD_STATUS_LABELS,
  WHATSAPP_CAPABILITIES,
  WHATSAPP_CONNECTION_STATES,
  WHATSAPP_CONNECTION_STATE_LABELS,
  WHATSAPP_CONNECTORS,
  WHATSAPP_HISTORY_MODES,
  WHATSAPP_HISTORY_MODE_LABELS,
  WHATSAPP_HISTORY_STATES,
  WHATSAPP_HISTORY_WINDOWS,
  WHATSAPP_UPLOAD_TYPES,
  ZONE_TIERS,
  ZONE_TIER_LABELS,
  activitiesContract,
  activityCompleteSchema,
  activityCreateSchema,
  activityListQuerySchema,
  activitySchema,
  activitySubjectSchema,
  activityTypeSchema,
  activityUpdateSchema,
  agencyAssistantModelsSchema,
  agencyCode,
  agencyContract,
  agencyCreateResultSchema,
  agencyCreateSchema,
  agencyDeletionPreviewSchema,
  agencyDeletionSchema,
  agencyDeletionStatusSchema,
  agencyRoleSchema,
  agencySchema,
  agencyUpdateSchema,
  agencyUserSchema,
  applyMergeFields,
  appointmentOutcomeSchema,
  appointmentTypeCreateSchema,
  appointmentTypeListQuerySchema,
  appointmentTypeSchema,
  appointmentTypeUpdateSchema,
  appointmentTypesContract,
  assistantContract,
  assistantCredentialStatusSchema,
  assistantMessageSchema,
  assistantModelOptionSchema,
  assistantRecordCardSchema,
  assistantRecordKindSchema,
  assistantRecordRefSchema,
  assistantRecordsRequestSchema,
  assistantReportCreateSchema,
  assistantReportStatusSchema,
  assistantSegmentSchema,
  assistantSessionCreateSchema,
  assistantSessionDetailSchema,
  assistantSessionModelSchema,
  assistantSessionSchema,
  assistantSessionUpdateSchema,
  assistantSettingsSchema,
  assistantUsageByModelSchema,
  assistantUsageByUserSchema,
  assistantUsageDaySchema,
  assistantUsageSummarySchema,
  authContract,
  booleanQuery,
  buildingCreateSchema,
  buildingListQuerySchema,
  buildingSchema,
  buildingUpdateSchema,
  buildingsContract,
  businessHoursSchema,
  callOutcomeSchema,
  campaignChannelSchema,
  campaignDetailSchema,
  campaignInputSchema,
  campaignRecipientSchema,
  campaignSchema,
  campaignStatusSchema,
  campaignStepInputSchema,
  campaignStepKindSchema,
  campaignStepSchema,
  campaignsContract,
  chartSpecSchema,
  chartTypeSchema,
  checkDigits,
  codiceFiscaleCheckChar,
  commonErrorResponses,
  comuneNearbyQuerySchema,
  comuneNearbySchema,
  comuneOptionSchema,
  consentChannelSchema,
  contactChannelInputSchema,
  contactChannelKindSchema,
  contactChannelSchema,
  contactClassificationEntrySchema,
  contactClassificationSchema,
  contactCreateSchema,
  contactDuplicateQuerySchema,
  contactDuplicateSchema,
  contactEmailStatusSchema,
  contactKindSchema,
  contactListQuerySchema,
  contactRelationInputSchema,
  contactRelationSchema,
  contactRelationTypeSchema,
  contactSchema,
  contactUpdateSchema,
  contactsContract,
  contract,
  contractTypeSchema,
  conversationSchema,
  conversationStateSchema,
  createAssistantPromptSchema,
  dashboardContract,
  dashboardSummarySchema,
  demandCreateSchema,
  demandListQuerySchema,
  demandMatchSchema,
  demandSchema,
  demandStatusSchema,
  demandUpdateSchema,
  demandsContract,
  derivedRoleSchema,
  describeLeadSource,
  dnsRecordSchema,
  emailContract,
  emailOptinInputSchema,
  emailOptinSourceKindSchema,
  energyClassSchema,
  enrollmentStatusSchema,
  enumOptions,
  errorSchema,
  exposureSchema,
  exteriorConditionSchema,
  floorLevelSchema,
  formatReference,
  freeSlug,
  garageTypeSchema,
  gardenTypeSchema,
  geoContract,
  geocodingContract,
  geocodingResultSchema,
  healthContract,
  heatingSchema,
  interiorConditionSchema,
  isMandateTerminal,
  isPropertyKnownAttribute,
  isValidCodiceFiscale,
  isValidPartitaIva,
  limitQuery,
  listQuerySchema,
  looksLikeReference,
  mandateActionSchema,
  mandateActions,
  mandateCreateSchema,
  mandateListQuerySchema,
  mandateSchema,
  mandateStatusSchema,
  mandateTarget,
  mandateTransitionSchema,
  mandateUpdateSchema,
  mandatesContract,
  mediaRoleSchema,
  messageDirectionSchema,
  messageMediaStateSchema,
  messageSchema,
  messageSendStatusSchema,
  messageSourceSchema,
  messageTemplateInputSchema,
  messageTemplateSchema,
  messageTypeSchema,
  normaliseReference,
  normalizePhone,
  normalizeTaxId,
  occupiedBySchema,
  ownershipTypeSchema,
  paginated,
  parseReference,
  partitaIvaCheckDigit,
  phoneMatchKey,
  platformAgencyMetricSchema,
  platformAgencySchema,
  platformAgencyUpdateSchema,
  platformAssistantModelSchema,
  platformAssistantPromptSchema,
  platformAssistantReportDetailSchema,
  platformAssistantReportSchema,
  platformAssistantUsageSchema,
  platformAssistantViewSchema,
  platformContract,
  platformEmailContract,
  platformFeatureUsageSchema,
  platformSessionSchema,
  platformUserSchema,
  propertiesContract,
  propertyAttributesSchema,
  propertyCreateSchema,
  propertyKnownAttributesSchema,
  propertyListQuerySchema,
  propertyMatchSchema,
  propertyMatchesContract,
  propertyMediaInputSchema,
  propertyMediaSchema,
  propertySchema,
  propertyStatusSchema,
  propertyTypologiesContract,
  propertyTypologyCreateSchema,
  propertyTypologyListQuerySchema,
  propertyTypologySchema,
  propertyTypologyUpdateSchema,
  propertyUpdateSchema,
  propertyUseSchema,
  provinciaOptionSchema,
  referenceHitSchema,
  referencesContract,
  regioneOptionSchema,
  registerAssistantModelSchema,
  reminderDueStateSchema,
  segmentConditionSchema,
  segmentConsentChannelSchema,
  segmentDefinitionSchema,
  segmentFieldSchema,
  segmentInputSchema,
  segmentPreviewSchema,
  segmentSchema,
  sendMessageSchema,
  sendingDomainInputSchema,
  sendingDomainOverviewSchema,
  sessionAgencySchema,
  sessionCapabilitiesSchema,
  sessionResponseSchema,
  sessionSchema,
  sessionUserSchema,
  setAssistantBudgetSchema,
  setAssistantCredentialSchema,
  slugify,
  summarizeFeatureUsage,
  typologyLevelSchema,
  unfinishedAgencyDeletionSchema,
  unknownMergeFields,
  updateAssistantSettingsSchema,
  updateAssistantViewSchema,
  uploadTicketRequestSchema,
  uploadTicketSchema,
  userInviteSchema,
  userOptionSchema,
  usersContract,
  utcToZonedLocal,
  websiteLeadKindSchema,
  websiteLeadSchema,
  websiteLeadStatusSchema,
  websiteLeadUpdateSchema,
  whatsappAccountSchema,
  whatsappCapabilitiesSchema,
  whatsappConnectionStateSchema,
  whatsappConnectorSchema,
  whatsappContract,
  whatsappHistoryChoiceSchema,
  whatsappHistoryModeSchema,
  whatsappHistorySchema,
  whatsappHistoryStateSchema,
  whatsappHistoryWindowSchema,
  whatsappQrSchema,
  whatsappStoredSchema,
  whatsappUploadTicketRequestSchema,
  whatsappUploadTicketSchema,
  zoneCatalogContract,
  zoneCreateSchema,
  zoneImportPreviewSchema,
  zoneImportResultSchema,
  zoneImportTierSchema,
  zoneListQuerySchema,
  zoneSchema,
  zoneUpdateSchema,
  zonedLocalToUtc,
  zonesContract
};
//# sourceMappingURL=index.js.map